(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-core'.");
    }
    globalThis['kotlinx-serialization-kotlinx-serialization-core'] = factory(typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined' ? {} : globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.ba;
  var initMetadataForInterface = kotlin_kotlin.$_$.h9;
  var VOID = kotlin_kotlin.$_$.b;
  var getKClassFromExpression = kotlin_kotlin.$_$.ra;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.d2;
  var Unit_instance = kotlin_kotlin.$_$.p2;
  var constructCallableReference = kotlin_kotlin.$_$.w8;
  var emptyList = kotlin_kotlin.$_$.e5;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.q2;
  var lazy = kotlin_kotlin.$_$.od;
  var KProperty1 = kotlin_kotlin.$_$.ua;
  var getPropertyCallableRef = kotlin_kotlin.$_$.b9;
  var toString = kotlin_kotlin.$_$.da;
  var initMetadataForClass = kotlin_kotlin.$_$.e9;
  var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.p3;
  var objectCreate = kotlin_kotlin.$_$.aa;
  var captureStack = kotlin_kotlin.$_$.o8;
  var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.q3;
  var IllegalArgumentException_init_$Init$_1 = kotlin_kotlin.$_$.s3;
  var IllegalArgumentException = kotlin_kotlin.$_$.oc;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.q4;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.s2;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.k;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.j;
  var THROW_CCE = kotlin_kotlin.$_$.tc;
  var isInterface = kotlin_kotlin.$_$.s9;
  var KClass = kotlin_kotlin.$_$.ta;
  var Triple = kotlin_kotlin.$_$.vc;
  var getKClass = kotlin_kotlin.$_$.sa;
  var Pair = kotlin_kotlin.$_$.qc;
  var Entry = kotlin_kotlin.$_$.i4;
  var KtMap = kotlin_kotlin.$_$.j4;
  var KtMutableMap = kotlin_kotlin.$_$.l4;
  var LinkedHashMap = kotlin_kotlin.$_$.f4;
  var HashMap = kotlin_kotlin.$_$.d4;
  var KtSet = kotlin_kotlin.$_$.n4;
  var KtMutableSet = kotlin_kotlin.$_$.m4;
  var LinkedHashSet = kotlin_kotlin.$_$.g4;
  var HashSet = kotlin_kotlin.$_$.e4;
  var Collection = kotlin_kotlin.$_$.c4;
  var KtList = kotlin_kotlin.$_$.h4;
  var KtMutableList = kotlin_kotlin.$_$.k4;
  var ArrayList = kotlin_kotlin.$_$.b4;
  var copyToArray = kotlin_kotlin.$_$.d5;
  var Result = kotlin_kotlin.$_$.rc;
  var ensureNotNull = kotlin_kotlin.$_$.kd;
  var equals = kotlin_kotlin.$_$.y8;
  var getStringHashCode = kotlin_kotlin.$_$.c9;
  var isBlank = kotlin_kotlin.$_$.bb;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.r3;
  var toList = kotlin_kotlin.$_$.p6;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.t2;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.z2;
  var toHashSet = kotlin_kotlin.$_$.n6;
  var toBooleanArray = kotlin_kotlin.$_$.m6;
  var withIndex = kotlin_kotlin.$_$.t6;
  var to = kotlin_kotlin.$_$.td;
  var toMap = kotlin_kotlin.$_$.r6;
  var lazy_0 = kotlin_kotlin.$_$.pd;
  var contentEquals = kotlin_kotlin.$_$.r4;
  var until = kotlin_kotlin.$_$.oa;
  var joinToString = kotlin_kotlin.$_$.o5;
  var initMetadataForObject = kotlin_kotlin.$_$.j9;
  var Long = kotlin_kotlin.$_$.pc;
  var Char = kotlin_kotlin.$_$.hc;
  var Duration__toIsoString_impl_9h6wsm = kotlin_kotlin.$_$.c;
  var Duration = kotlin_kotlin.$_$.fc;
  var Companion_getInstance = kotlin_kotlin.$_$.g2;
  var Uuid = kotlin_kotlin.$_$.gc;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.h2;
  var toIntOrNull = kotlin_kotlin.$_$.ub;
  var hashCode = kotlin_kotlin.$_$.d9;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.t3;
  var ArrayList_init_$Create$_1 = kotlin_kotlin.$_$.u2;
  var HashSet_init_$Create$_0 = kotlin_kotlin.$_$.a3;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.e3;
  var LinkedHashSet_init_$Create$_0 = kotlin_kotlin.$_$.f3;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.w2;
  var HashMap_init_$Create$_0 = kotlin_kotlin.$_$.x2;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.c3;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.d3;
  var isArray = kotlin_kotlin.$_$.k9;
  var arrayIterator = kotlin_kotlin.$_$.m8;
  var asList = kotlin_kotlin.$_$.p4;
  var step = kotlin_kotlin.$_$.na;
  var getValue = kotlin_kotlin.$_$.k5;
  var longArray = kotlin_kotlin.$_$.w9;
  var initMetadataForCompanion = kotlin_kotlin.$_$.f9;
  var get_lastIndex = kotlin_kotlin.$_$.p5;
  var shiftLeft = kotlin_kotlin.$_$.h8;
  var bitwiseOr = kotlin_kotlin.$_$.s7;
  var equalsLong = kotlin_kotlin.$_$.y7;
  var invert = kotlin_kotlin.$_$.a8;
  var countTrailingZeroBits = kotlin_kotlin.$_$.id;
  var indexOf = kotlin_kotlin.$_$.l5;
  var contentToString = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.lc;
  var toString_0 = kotlin_kotlin.$_$.sd;
  var KTypeParameter = kotlin_kotlin.$_$.va;
  var HashSet_init_$Create$_1 = kotlin_kotlin.$_$.y2;
  var contentHashCode = kotlin_kotlin.$_$.s4;
  var booleanArray = kotlin_kotlin.$_$.n8;
  var emptyMap = kotlin_kotlin.$_$.f5;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.i2;
  var isCharArray = kotlin_kotlin.$_$.n9;
  var charArray = kotlin_kotlin.$_$.q8;
  var DoubleCompanionObject_instance = kotlin_kotlin.$_$.z1;
  var isDoubleArray = kotlin_kotlin.$_$.p9;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.a2;
  var isFloatArray = kotlin_kotlin.$_$.q9;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.j2;
  var isLongArray = kotlin_kotlin.$_$.b8;
  var Companion_getInstance_3 = kotlin_kotlin.$_$.n2;
  var _ULongArray___get_size__impl__ju6dtr = kotlin_kotlin.$_$.k1;
  var ULongArray = kotlin_kotlin.$_$.ad;
  var _ULongArray___init__impl__twm1l3 = kotlin_kotlin.$_$.g1;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.d1;
  var ULongArray__get_impl_pr71q9 = kotlin_kotlin.$_$.i1;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.e1;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.b2;
  var isIntArray = kotlin_kotlin.$_$.r9;
  var Companion_getInstance_4 = kotlin_kotlin.$_$.m2;
  var _UIntArray___get_size__impl__r6l8ci = kotlin_kotlin.$_$.b1;
  var UIntArray = kotlin_kotlin.$_$.yc;
  var _UIntArray___init__impl__ghjpc6 = kotlin_kotlin.$_$.x;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.u;
  var UIntArray__get_impl_gp5kza = kotlin_kotlin.$_$.z;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.v;
  var ShortCompanionObject_instance = kotlin_kotlin.$_$.c2;
  var isShortArray = kotlin_kotlin.$_$.t9;
  var Companion_getInstance_5 = kotlin_kotlin.$_$.o2;
  var _UShortArray___get_size__impl__jqto1b = kotlin_kotlin.$_$.t1;
  var UShortArray = kotlin_kotlin.$_$.cd;
  var _UShortArray___init__impl__9b26ef = kotlin_kotlin.$_$.p1;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.m1;
  var UShortArray__get_impl_fnbhmx = kotlin_kotlin.$_$.r1;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.n1;
  var ByteCompanionObject_instance = kotlin_kotlin.$_$.y1;
  var isByteArray = kotlin_kotlin.$_$.m9;
  var Companion_getInstance_6 = kotlin_kotlin.$_$.l2;
  var _UByteArray___get_size__impl__h6pkdv = kotlin_kotlin.$_$.s;
  var UByteArray = kotlin_kotlin.$_$.wc;
  var _UByteArray___init__impl__ip4y9n = kotlin_kotlin.$_$.p;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.l;
  var UByteArray__get_impl_t5f3hv = kotlin_kotlin.$_$.q;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.m;
  var BooleanCompanionObject_instance = kotlin_kotlin.$_$.x1;
  var isBooleanArray = kotlin_kotlin.$_$.l9;
  var coerceAtLeast = kotlin_kotlin.$_$.ha;
  var copyOf = kotlin_kotlin.$_$.x4;
  var copyOf_0 = kotlin_kotlin.$_$.z4;
  var copyOf_1 = kotlin_kotlin.$_$.a5;
  var copyOf_2 = kotlin_kotlin.$_$.v4;
  var _ULongArray___get_storage__impl__28e64j = kotlin_kotlin.$_$.l1;
  var _ULongArray___init__impl__twm1l3_0 = kotlin_kotlin.$_$.h1;
  var ULongArray__set_impl_z19mvh = kotlin_kotlin.$_$.j1;
  var copyOf_3 = kotlin_kotlin.$_$.c5;
  var _UIntArray___get_storage__impl__92a0v0 = kotlin_kotlin.$_$.c1;
  var _UIntArray___init__impl__ghjpc6_0 = kotlin_kotlin.$_$.y;
  var UIntArray__set_impl_7f2zu2 = kotlin_kotlin.$_$.a1;
  var copyOf_4 = kotlin_kotlin.$_$.u4;
  var _UShortArray___get_storage__impl__t2jpv5 = kotlin_kotlin.$_$.u1;
  var _UShortArray___init__impl__9b26ef_0 = kotlin_kotlin.$_$.q1;
  var UShortArray__set_impl_6d8whp = kotlin_kotlin.$_$.s1;
  var copyOf_5 = kotlin_kotlin.$_$.y4;
  var _UByteArray___get_storage__impl__d4kctt = kotlin_kotlin.$_$.t;
  var _UByteArray___init__impl__ip4y9n_0 = kotlin_kotlin.$_$.o;
  var UByteArray__set_impl_jvcicn = kotlin_kotlin.$_$.r;
  var copyOf_6 = kotlin_kotlin.$_$.w4;
  var trimIndent = kotlin_kotlin.$_$.dc;
  var Unit = kotlin_kotlin.$_$.ed;
  var charSequenceLength = kotlin_kotlin.$_$.t8;
  var lastOrNull = kotlin_kotlin.$_$.r5;
  var get_lastIndex_0 = kotlin_kotlin.$_$.q5;
  var ULong = kotlin_kotlin.$_$.bd;
  var UInt = kotlin_kotlin.$_$.zc;
  var UByte = kotlin_kotlin.$_$.xc;
  var UShort = kotlin_kotlin.$_$.dd;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.qd;
  var get_js = kotlin_kotlin.$_$.u9;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.f2;
  var findAssociatedObject = kotlin_kotlin.$_$.a;
  var get_indices = kotlin_kotlin.$_$.n5;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.v3;
  var get_indices_0 = kotlin_kotlin.$_$.m5;
  var get_longArrayClass = kotlin_kotlin.$_$.c8;
  var mapOf = kotlin_kotlin.$_$.y5;
  var Companion_instance = kotlin_kotlin.$_$.k2;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.h;
  var createFailure = kotlin_kotlin.$_$.jd;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
  initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
  initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
  initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForClass(SerializationException, 'SerializationException', SerializationException_init_$Create$, IllegalArgumentException);
  initMetadataForClass(MissingFieldException, 'MissingFieldException', VOID, SerializationException);
  initMetadataForClass(UnknownFieldException, 'UnknownFieldException', VOID, SerializationException);
  function get_isNullable() {
    return false;
  }
  function get_isInline() {
    return false;
  }
  function get_annotations() {
    return emptyList();
  }
  initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
  initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(elementDescriptors$1);
  initMetadataForClass(elementDescriptors$$inlined$Iterable$1);
  initMetadataForClass(elementNames$1);
  initMetadataForClass(elementNames$$inlined$Iterable$1);
  initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
  initMetadataForInterface(CachedNames, 'CachedNames');
  initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(SerialKind, 'SerialKind');
  initMetadataForClass(PolymorphicKind, 'PolymorphicKind', VOID, SerialKind);
  initMetadataForObject(SEALED, 'SEALED', VOID, PolymorphicKind);
  initMetadataForObject(OPEN, 'OPEN', VOID, PolymorphicKind);
  initMetadataForObject(ENUM, 'ENUM', VOID, SerialKind);
  initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL', VOID, SerialKind);
  initMetadataForClass(PrimitiveKind, 'PrimitiveKind', VOID, SerialKind);
  initMetadataForObject(BOOLEAN, 'BOOLEAN', VOID, PrimitiveKind);
  initMetadataForObject(BYTE, 'BYTE', VOID, PrimitiveKind);
  initMetadataForObject(CHAR, 'CHAR', VOID, PrimitiveKind);
  initMetadataForObject(SHORT, 'SHORT', VOID, PrimitiveKind);
  initMetadataForObject(INT, 'INT', VOID, PrimitiveKind);
  initMetadataForObject(LONG, 'LONG', VOID, PrimitiveKind);
  initMetadataForObject(FLOAT, 'FLOAT', VOID, PrimitiveKind);
  initMetadataForObject(DOUBLE, 'DOUBLE', VOID, PrimitiveKind);
  initMetadataForObject(STRING, 'STRING', VOID, PrimitiveKind);
  initMetadataForClass(StructureKind, 'StructureKind', VOID, SerialKind);
  initMetadataForObject(CLASS, 'CLASS', VOID, StructureKind);
  initMetadataForObject(LIST, 'LIST', VOID, StructureKind);
  initMetadataForObject(MAP, 'MAP', VOID, StructureKind);
  initMetadataForObject(OBJECT, 'OBJECT', VOID, StructureKind);
  function decodeSerializableValue(deserializer) {
    return deserializer.gj(this);
  }
  initMetadataForInterface(Decoder, 'Decoder');
  function decodeSequentially() {
    return false;
  }
  function decodeCollectionSize(descriptor) {
    return -1;
  }
  function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
    previousValue = previousValue === VOID ? null : previousValue;
    return $super === VOID ? this.rm(descriptor, index, deserializer, previousValue) : $super.rm.call(this, descriptor, index, deserializer, previousValue);
  }
  initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
  initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  function encodeNotNullMark() {
  }
  function beginCollection(descriptor, collectionSize) {
    return this.fm(descriptor);
  }
  function encodeSerializableValue(serializer, value) {
    serializer.fj(this, value);
  }
  function encodeNullableSerializableValue(serializer, value) {
    var isNullabilitySupported = serializer.ej().ek();
    if (isNullabilitySupported) {
      return this.xn(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
    }
    if (value == null) {
      this.an();
    } else {
      this.ao();
      this.xn(serializer, value);
    }
  }
  initMetadataForInterface(Encoder, 'Encoder');
  function shouldEncodeElementDefault(descriptor, index) {
    return true;
  }
  initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
  initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForObject(NothingSerializer_0, 'NothingSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UuidSerializer, 'UuidSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', VOID, ListLikeDescriptor);
  initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(CollectionSerializer, 'CollectionSerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer', VOID, CollectionSerializer);
  initMetadataForClass(HashSetSerializer, 'HashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(HashMapSerializer, 'HashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
  initMetadataForCompanion(Companion);
  initMetadataForClass(ElementMarker, 'ElementMarker');
  initMetadataForClass(EnumSerializer, 'EnumSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(EnumDescriptor, 'EnumDescriptor', VOID, PluginGeneratedSerialDescriptor);
  initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor', VOID, PluginGeneratedSerialDescriptor);
  function typeParametersSerializers() {
    return get_EMPTY_SERIALIZER_ARRAY();
  }
  initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
  initMetadataForObject(NoOpEncoder, 'NoOpEncoder', VOID, AbstractEncoder);
  initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForInterface(SerializerFactory, 'SerializerFactory');
  initMetadataForObject(CharArraySerializer_0, 'CharArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(DoubleArraySerializer_0, 'DoubleArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(FloatArraySerializer_0, 'FloatArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(LongArraySerializer_0, 'LongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(ULongArraySerializer_0, 'ULongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(IntArraySerializer_0, 'IntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(UIntArraySerializer_0, 'UIntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(ShortArraySerializer_0, 'ShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(UShortArraySerializer_0, 'UShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(ByteArraySerializer_0, 'ByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(UByteArraySerializer_0, 'UByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(BooleanArraySerializer_0, 'BooleanArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder', VOID, TaggedDecoder);
  initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
  initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(MapEntrySerializer_0, 'MapEntrySerializer', VOID, KeyValueSerializer);
  initMetadataForClass(PairSerializer_0, 'PairSerializer', VOID, KeyValueSerializer);
  initMetadataForClass(TripleSerializer_0, 'TripleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerializersModule, 'SerializersModule');
  initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl', VOID, SerializersModule);
  initMetadataForClass(ContextualProvider, 'ContextualProvider');
  initMetadataForClass(Argless, 'Argless', VOID, ContextualProvider);
  initMetadataForClass(WithTypeArguments, 'WithTypeArguments', VOID, ContextualProvider);
  function contextual(kClass, serializer) {
    return this.v12(kClass, SerializersModuleCollector$contextual$lambda(serializer));
  }
  initMetadataForInterface(SerializersModuleCollector, 'SerializersModuleCollector');
  initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
  initMetadataForClass(createCache$1);
  initMetadataForClass(createParametrizedCache$1);
  //endregion
  function SerializationStrategy() {
  }
  function DeserializationStrategy() {
  }
  function KSerializer() {
  }
  function findPolymorphicSerializer(_this__u8e3s4, decoder, klassName) {
    var tmp0_elvis_lhs = _this__u8e3s4.hj(decoder, klassName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered(klassName, _this__u8e3s4.ij());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function findPolymorphicSerializer_0(_this__u8e3s4, encoder, value) {
    var tmp0_elvis_lhs = _this__u8e3s4.jj(encoder, value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered_0(getKClassFromExpression(value), _this__u8e3s4.ij());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.sj('type', serializer_0(StringCompanionObject_instance).ej());
      $this$buildSerialDescriptor.sj('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.tj_1.o() + '>', CONTEXTUAL_getInstance(), []));
      $this$buildSerialDescriptor.mj_1 = this$0.uj_1;
      return Unit_instance;
    };
  }
  function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
    return function () {
      var tmp = OPEN_getInstance();
      return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.tj_1);
    };
  }
  function PolymorphicSerializer$_get_descriptor_$ref_8tw9if() {
    return constructCallableReference(function (p0) {
      return p0.ej();
    }, 1, 0, 0);
  }
  function PolymorphicSerializer(baseClass) {
    AbstractPolymorphicSerializer.call(this);
    this.tj_1 = baseClass;
    this.uj_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.vj_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
  }
  protoOf(PolymorphicSerializer).ij = function () {
    return this.tj_1;
  };
  protoOf(PolymorphicSerializer).ej = function () {
    var tmp0 = this.vj_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, PolymorphicSerializer$_get_descriptor_$ref_8tw9if(), null);
    return tmp0.f2();
  };
  protoOf(PolymorphicSerializer).toString = function () {
    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.tj_1) + ')';
  };
  function SealedClassSerializer$_get_descriptor_$ref_m511rz() {
    return constructCallableReference(function (p0) {
      return p0.ej();
    }, 1, 0, 1);
  }
  function SealedClassSerializer() {
  }
  protoOf(SealedClassSerializer).ej = function () {
    var tmp0 = this.xj_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, SealedClassSerializer$_get_descriptor_$ref_m511rz(), null);
    return tmp0.f2();
  };
  function SerializationException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$() {
    var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$);
    return tmp;
  }
  function SerializationException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$_0(message) {
    var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$_0);
    return tmp;
  }
  function SerializationException_init_$Init$_1(message, cause, $this) {
    IllegalArgumentException_init_$Init$_1(message, cause, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException() {
    captureStack(this, SerializationException);
  }
  function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
    MissingFieldException.call($this, missingFields, missingFields.z() === 1 ? "Field '" + missingFields.a1(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
    return $this;
  }
  function MissingFieldException_init_$Create$(missingFields, serialName) {
    var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
    captureStack(tmp, MissingFieldException_init_$Create$);
    return tmp;
  }
  function MissingFieldException(missingFields, message, cause) {
    SerializationException_init_$Init$_1(message, cause, this);
    captureStack(this, MissingFieldException);
    this.yj_1 = missingFields;
  }
  function UnknownFieldException_init_$Init$(index, $this) {
    UnknownFieldException.call($this, 'An unknown field for index ' + index);
    return $this;
  }
  function UnknownFieldException_init_$Create$(index) {
    var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
    captureStack(tmp, UnknownFieldException_init_$Create$);
    return tmp;
  }
  function UnknownFieldException(message) {
    SerializationException_init_$Init$_0(message, this);
    captureStack(this, UnknownFieldException);
  }
  function serializer(_this__u8e3s4, type) {
    var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      platformSpecificSerializerNotRegistered(kclass(type));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
    var rootClass = kclass(type);
    var isNullable = type.l();
    // Inline function 'kotlin.collections.map' call
    var this_0 = type.k();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = typeOrThrow(item);
      destination.x(tmp$ret$2);
    }
    var typeArguments = destination;
    var tmp;
    if (typeArguments.r()) {
      var tmp_0;
      if (isInterface_0(rootClass) && !(_this__u8e3s4.ak(rootClass) == null)) {
        tmp_0 = null;
      } else {
        tmp_0 = findCachedSerializer(rootClass, isNullable);
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if (_this__u8e3s4.zj()) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.Result.getOrNull' call
        var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
        tmp_1 = _Result___get_isFailure__impl__jpiriv(this_1) ? null : _Result___get_value__impl__bjfvqg(this_1);
      }
      tmp = tmp_1;
    }
    var cachedSerializer = tmp;
    if (!(cachedSerializer == null))
      return cachedSerializer;
    var tmp_2;
    if (typeArguments.r()) {
      var tmp0_elvis_lhs = serializerOrNull(rootClass);
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? _this__u8e3s4.ak(rootClass) : tmp0_elvis_lhs;
      var tmp_3;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
        tmp_3 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
      } else {
        tmp_3 = tmp1_elvis_lhs;
      }
      tmp_2 = tmp_3;
    } else {
      var tmp2_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
      var tmp_4;
      if (tmp2_elvis_lhs == null) {
        return null;
      } else {
        tmp_4 = tmp2_elvis_lhs;
      }
      var serializers = tmp_4;
      var tmp3_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
      var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? _this__u8e3s4.bk(rootClass, serializers) : tmp3_elvis_lhs;
      var tmp_5;
      if (tmp4_elvis_lhs == null) {
        // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
        tmp_5 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
      } else {
        tmp_5 = tmp4_elvis_lhs;
      }
      tmp_2 = tmp_5;
    }
    var contextualSerializer = tmp_2;
    var tmp_6;
    if (contextualSerializer == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_6 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
    }
    var tmp6_safe_receiver = tmp_6;
    return tmp6_safe_receiver == null ? null : nullable(tmp6_safe_receiver, isNullable);
  }
  function serializerOrNull(_this__u8e3s4) {
    var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
    var tmp;
    if (failOnMissingTypeArgSerializer) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var _iterator__ex2g4s = typeArguments.t();
      while (_iterator__ex2g4s.u()) {
        var item = _iterator__ex2g4s.v();
        var tmp$ret$2 = serializer(_this__u8e3s4, item);
        destination.x(tmp$ret$2);
      }
      tmp = destination;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var _iterator__ex2g4s_0 = typeArguments.t();
      while (_iterator__ex2g4s_0.u()) {
        var item_0 = _iterator__ex2g4s_0.v();
        var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$5 = tmp_0;
        destination_0.x(tmp$ret$5);
      }
      tmp = destination_0;
    }
    var serializers = tmp;
    return serializers;
  }
  function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
    return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
  }
  function nullable(_this__u8e3s4, shouldBeNullable) {
    if (shouldBeNullable)
      return get_nullable(_this__u8e3s4);
    return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  }
  function serializerOrNull_0(_this__u8e3s4, type) {
    return serializerByKTypeImpl(_this__u8e3s4, type, false);
  }
  function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp;
    if (_this__u8e3s4.equals(getKClass(Collection)) || _this__u8e3s4.equals(getKClass(KtList)) || (_this__u8e3s4.equals(getKClass(KtMutableList)) || _this__u8e3s4.equals(getKClass(ArrayList)))) {
      tmp = new ArrayListSerializer(serializers.a1(0));
    } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
      tmp = new HashSetSerializer(serializers.a1(0));
    } else if (_this__u8e3s4.equals(getKClass(KtSet)) || (_this__u8e3s4.equals(getKClass(KtMutableSet)) || _this__u8e3s4.equals(getKClass(LinkedHashSet)))) {
      tmp = new LinkedHashSetSerializer(serializers.a1(0));
    } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
      tmp = new HashMapSerializer(serializers.a1(0), serializers.a1(1));
    } else if (_this__u8e3s4.equals(getKClass(KtMap)) || (_this__u8e3s4.equals(getKClass(KtMutableMap)) || _this__u8e3s4.equals(getKClass(LinkedHashMap)))) {
      tmp = new LinkedHashMapSerializer(serializers.a1(0), serializers.a1(1));
    } else if (_this__u8e3s4.equals(getKClass(Entry))) {
      tmp = MapEntrySerializer(serializers.a1(0), serializers.a1(1));
    } else if (_this__u8e3s4.equals(getKClass(Pair))) {
      tmp = PairSerializer(serializers.a1(0), serializers.a1(1));
    } else if (_this__u8e3s4.equals(getKClass(Triple))) {
      tmp = TripleSerializer(serializers.a1(0), serializers.a1(1), serializers.a1(2));
    } else {
      var tmp_0;
      if (isReferenceArray(_this__u8e3s4)) {
        var tmp_1 = elementClassifierIfArray();
        tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.a1(0));
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(serializers);
    return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
  }
  function serializerByKTypeImpl$lambda($typeArguments) {
    return function () {
      return $typeArguments.a1(0).j();
    };
  }
  function get_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE;
  }
  var SERIALIZERS_CACHE;
  function get_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE_NULLABLE;
  }
  var SERIALIZERS_CACHE_NULLABLE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  function findCachedSerializer(clazz, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp0_safe_receiver = get_SERIALIZERS_CACHE().ck(clazz);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlinx.serialization.internal.cast' call
        tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
      }
      tmp = tmp_0;
    } else {
      tmp = get_SERIALIZERS_CACHE_NULLABLE().ck(clazz);
    }
    return tmp;
  }
  function findParametrizedCachedSerializer(clazz, types, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().dk(clazz, types);
      tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
    } else {
      tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().dk(clazz, types);
    }
    return tmp;
  }
  function SERIALIZERS_CACHE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp0_elvis_lhs = serializerOrNull(it);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp0_elvis_lhs = serializerOrNull(it);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_nullable(tmp1_safe_receiver);
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_0 = isInterface(tmp2_safe_receiver, KSerializer) ? tmp2_safe_receiver : THROW_CCE();
    }
    return tmp_0;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
    return function () {
      return $types.a1(0).j();
    };
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
    return function () {
      return $types.a1(0).j();
    };
  }
  var properties_initialized_SerializersCache_kt_q8kf25;
  function _init_properties_SerializersCache_kt__hgwi2p() {
    if (!properties_initialized_SerializersCache_kt_q8kf25) {
      properties_initialized_SerializersCache_kt_q8kf25 = true;
      SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
      SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
    }
  }
  function serializer_0(_this__u8e3s4) {
    return StringSerializer_getInstance();
  }
  function serializer_1(_this__u8e3s4) {
    return ULongSerializer_getInstance();
  }
  function MapSerializer(keySerializer, valueSerializer) {
    return new LinkedHashMapSerializer(keySerializer, valueSerializer);
  }
  function ListSerializer(elementSerializer) {
    return new ArrayListSerializer(elementSerializer);
  }
  function serializer_2(_this__u8e3s4) {
    return UIntSerializer_getInstance();
  }
  function serializer_3(_this__u8e3s4) {
    return UByteSerializer_getInstance();
  }
  function serializer_4(_this__u8e3s4) {
    return UShortSerializer_getInstance();
  }
  function get_nullable(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.ej().ek()) {
      tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
    } else {
      tmp = new NullableSerializer(_this__u8e3s4);
    }
    return tmp;
  }
  function MapEntrySerializer(keySerializer, valueSerializer) {
    return new MapEntrySerializer_0(keySerializer, valueSerializer);
  }
  function PairSerializer(keySerializer, valueSerializer) {
    return new PairSerializer_0(keySerializer, valueSerializer);
  }
  function TripleSerializer(aSerializer, bSerializer, cSerializer) {
    return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
  }
  function ArraySerializer(kClass, elementSerializer) {
    return new ReferenceArraySerializer(kClass, elementSerializer);
  }
  function serializer_5(_this__u8e3s4) {
    return LongSerializer_getInstance();
  }
  function serializer_6(_this__u8e3s4) {
    return IntSerializer_getInstance();
  }
  function serializer_7(_this__u8e3s4) {
    return ByteSerializer_getInstance();
  }
  function serializer_8(_this__u8e3s4) {
    return ShortSerializer_getInstance();
  }
  function serializer_9(_this__u8e3s4) {
    return CharSerializer_getInstance();
  }
  function CharArraySerializer() {
    return CharArraySerializer_getInstance();
  }
  function serializer_10(_this__u8e3s4) {
    return DoubleSerializer_getInstance();
  }
  function DoubleArraySerializer() {
    return DoubleArraySerializer_getInstance();
  }
  function serializer_11(_this__u8e3s4) {
    return FloatSerializer_getInstance();
  }
  function FloatArraySerializer() {
    return FloatArraySerializer_getInstance();
  }
  function LongArraySerializer() {
    return LongArraySerializer_getInstance();
  }
  function ULongArraySerializer() {
    return ULongArraySerializer_getInstance();
  }
  function IntArraySerializer() {
    return IntArraySerializer_getInstance();
  }
  function UIntArraySerializer() {
    return UIntArraySerializer_getInstance();
  }
  function ShortArraySerializer() {
    return ShortArraySerializer_getInstance();
  }
  function UShortArraySerializer() {
    return UShortArraySerializer_getInstance();
  }
  function ByteArraySerializer() {
    return ByteArraySerializer_getInstance();
  }
  function UByteArraySerializer() {
    return UByteArraySerializer_getInstance();
  }
  function serializer_12(_this__u8e3s4) {
    return BooleanSerializer_getInstance();
  }
  function BooleanArraySerializer() {
    return BooleanArraySerializer_getInstance();
  }
  function serializer_13(_this__u8e3s4) {
    return UnitSerializer_getInstance();
  }
  function NothingSerializer() {
    return NothingSerializer_getInstance();
  }
  function serializer_14(_this__u8e3s4) {
    return DurationSerializer_getInstance();
  }
  function serializer_15(_this__u8e3s4) {
    return UuidSerializer_getInstance();
  }
  function getContextualDescriptor(_this__u8e3s4, descriptor) {
    var tmp0_safe_receiver = get_capturedKClass(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = _this__u8e3s4.ak(tmp0_safe_receiver);
      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.ej();
    }
    return tmp;
  }
  function get_capturedKClass(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ContextDescriptor) {
      tmp = _this__u8e3s4.jk_1;
    } else {
      if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
        tmp = get_capturedKClass(_this__u8e3s4.fk_1);
      } else {
        tmp = null;
      }
    }
    return tmp;
  }
  function ContextDescriptor(original, kClass) {
    this.ik_1 = original;
    this.jk_1 = kClass;
    this.kk_1 = this.ik_1.lk() + '<' + this.jk_1.o() + '>';
  }
  protoOf(ContextDescriptor).lk = function () {
    return this.kk_1;
  };
  protoOf(ContextDescriptor).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals(this.ik_1, another.ik_1) && another.jk_1.equals(this.jk_1);
  };
  protoOf(ContextDescriptor).hashCode = function () {
    var result = this.jk_1.hashCode();
    result = imul(31, result) + getStringHashCode(this.kk_1) | 0;
    return result;
  };
  protoOf(ContextDescriptor).toString = function () {
    return 'ContextDescriptor(kClass: ' + toString(this.jk_1) + ', original: ' + toString(this.ik_1) + ')';
  };
  protoOf(ContextDescriptor).mk = function () {
    return this.ik_1.mk();
  };
  protoOf(ContextDescriptor).ek = function () {
    return this.ik_1.ek();
  };
  protoOf(ContextDescriptor).nk = function () {
    return this.ik_1.nk();
  };
  protoOf(ContextDescriptor).ok = function () {
    return this.ik_1.ok();
  };
  protoOf(ContextDescriptor).pk = function () {
    return this.ik_1.pk();
  };
  protoOf(ContextDescriptor).qk = function (index) {
    return this.ik_1.qk(index);
  };
  protoOf(ContextDescriptor).rk = function (name) {
    return this.ik_1.rk(name);
  };
  protoOf(ContextDescriptor).sk = function (index) {
    return this.ik_1.sk(index);
  };
  protoOf(ContextDescriptor).tk = function (index) {
    return this.ik_1.tk(index);
  };
  protoOf(ContextDescriptor).uk = function (index) {
    return this.ik_1.uk(index);
  };
  function withContext(_this__u8e3s4, context) {
    return new ContextDescriptor(_this__u8e3s4, context);
  }
  function SerialDescriptor() {
  }
  function get_elementDescriptors(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new elementDescriptors$$inlined$Iterable$1(_this__u8e3s4);
  }
  function get_elementNames(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new elementNames$$inlined$Iterable$1(_this__u8e3s4);
  }
  function elementDescriptors$1($this_elementDescriptors) {
    this.wk_1 = $this_elementDescriptors;
    this.vk_1 = $this_elementDescriptors.ok();
  }
  protoOf(elementDescriptors$1).u = function () {
    return this.vk_1 > 0;
  };
  protoOf(elementDescriptors$1).v = function () {
    var tmp = this.wk_1.ok();
    var _unary__edvuaz = this.vk_1;
    this.vk_1 = _unary__edvuaz - 1 | 0;
    return this.wk_1.tk(tmp - _unary__edvuaz | 0);
  };
  function elementDescriptors$$inlined$Iterable$1($this_elementDescriptors) {
    this.xk_1 = $this_elementDescriptors;
  }
  protoOf(elementDescriptors$$inlined$Iterable$1).t = function () {
    return new elementDescriptors$1(this.xk_1);
  };
  function elementNames$1($this_elementNames) {
    this.zk_1 = $this_elementNames;
    this.yk_1 = $this_elementNames.ok();
  }
  protoOf(elementNames$1).u = function () {
    return this.yk_1 > 0;
  };
  protoOf(elementNames$1).v = function () {
    var tmp = this.zk_1.ok();
    var _unary__edvuaz = this.yk_1;
    this.yk_1 = _unary__edvuaz - 1 | 0;
    return this.zk_1.qk(tmp - _unary__edvuaz | 0);
  };
  function elementNames$$inlined$Iterable$1($this_elementNames) {
    this.al_1 = $this_elementNames;
  }
  protoOf(elementNames$$inlined$Iterable$1).t = function () {
    return new elementNames$1(this.al_1);
  };
  function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
    var tmp;
    if (builder === VOID) {
      tmp = buildSerialDescriptor$lambda;
    } else {
      tmp = builder;
    }
    builder = tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!!equals(kind, CLASS_getInstance())) {
      var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builder(sdBuilder);
    return new SerialDescriptorImpl(serialName, kind, sdBuilder.nj_1.z(), toList(typeParameters), sdBuilder);
  }
  function ClassSerialDescriptorBuilder(serialName) {
    this.kj_1 = serialName;
    this.lj_1 = false;
    this.mj_1 = emptyList();
    this.nj_1 = ArrayList_init_$Create$_0();
    this.oj_1 = HashSet_init_$Create$();
    this.pj_1 = ArrayList_init_$Create$_0();
    this.qj_1 = ArrayList_init_$Create$_0();
    this.rj_1 = ArrayList_init_$Create$_0();
  }
  protoOf(ClassSerialDescriptorBuilder).bl = function (elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    if (!this.oj_1.x(elementName)) {
      var message = "Element with name '" + elementName + "' is already registered in " + this.kj_1;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.nj_1.x(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.pj_1.x(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.qj_1.x(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.rj_1.x(isOptional);
  };
  protoOf(ClassSerialDescriptorBuilder).sj = function (elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.bl(elementName, descriptor, annotations, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.bl.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  };
  function PrimitiveSerialDescriptor(serialName, kind) {
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return PrimitiveDescriptorSafe(serialName, kind);
  }
  function _get__hashCode__tgwhef($this) {
    var tmp0 = $this.nl_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('_hashCode', 1, tmp, SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp(), null);
    return tmp0.f2();
  }
  function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.ml_1);
    };
  }
  function SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp() {
    return constructCallableReference(function (p0) {
      return _get__hashCode__tgwhef(p0);
    }, 1, 0, 2);
  }
  function SerialDescriptorImpl$toString$lambda(this$0) {
    return function (it) {
      return this$0.qk(it) + ': ' + this$0.tk(it).lk();
    };
  }
  function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
    this.cl_1 = serialName;
    this.dl_1 = kind;
    this.el_1 = elementsCount;
    this.fl_1 = builder.mj_1;
    this.gl_1 = toHashSet(builder.nj_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.nj_1;
    tmp.hl_1 = copyToArray(this_0);
    this.il_1 = compactArray(builder.pj_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = builder.qj_1;
    tmp_0.jl_1 = copyToArray(this_1);
    this.kl_1 = toBooleanArray(builder.rj_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = withIndex(this.hl_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s = this_2.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$4 = to(item.ed_1, item.dd_1);
      destination.x(tmp$ret$4);
    }
    tmp_1.ll_1 = toMap(destination);
    this.ml_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.nl_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  protoOf(SerialDescriptorImpl).lk = function () {
    return this.cl_1;
  };
  protoOf(SerialDescriptorImpl).mk = function () {
    return this.dl_1;
  };
  protoOf(SerialDescriptorImpl).ok = function () {
    return this.el_1;
  };
  protoOf(SerialDescriptorImpl).pk = function () {
    return this.fl_1;
  };
  protoOf(SerialDescriptorImpl).ol = function () {
    return this.gl_1;
  };
  protoOf(SerialDescriptorImpl).qk = function (index) {
    return getChecked(this.hl_1, index);
  };
  protoOf(SerialDescriptorImpl).rk = function (name) {
    var tmp0_elvis_lhs = this.ll_1.i2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(SerialDescriptorImpl).sk = function (index) {
    return getChecked(this.jl_1, index);
  };
  protoOf(SerialDescriptorImpl).tk = function (index) {
    return getChecked(this.il_1, index);
  };
  protoOf(SerialDescriptorImpl).uk = function (index) {
    return getChecked_0(this.kl_1, index);
  };
  protoOf(SerialDescriptorImpl).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.lk() === other.lk())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!contentEquals(this.ml_1, other.ml_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ok() === other.ok())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.ok();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.tk(index).lk() === other.tk(index).lk())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.tk(index).mk(), other.tk(index).mk())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SerialDescriptorImpl).hashCode = function () {
    return _get__hashCode__tgwhef(this);
  };
  protoOf(SerialDescriptorImpl).toString = function () {
    var tmp = until(0, this.el_1);
    var tmp_0 = this.cl_1 + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
  };
  function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
    var tmp;
    if (builderAction === VOID) {
      tmp = buildClassSerialDescriptor$lambda;
    } else {
      tmp = builderAction;
    }
    builderAction = tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builderAction(sdBuilder);
    return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.nj_1.z(), toList(typeParameters), sdBuilder);
  }
  function buildSerialDescriptor$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function SEALED() {
    SEALED_instance = this;
    PolymorphicKind.call(this);
  }
  var SEALED_instance;
  function SEALED_getInstance() {
    if (SEALED_instance == null)
      new SEALED();
    return SEALED_instance;
  }
  function OPEN() {
    OPEN_instance = this;
    PolymorphicKind.call(this);
  }
  var OPEN_instance;
  function OPEN_getInstance() {
    if (OPEN_instance == null)
      new OPEN();
    return OPEN_instance;
  }
  function PolymorphicKind() {
    SerialKind.call(this);
  }
  function ENUM() {
    ENUM_instance = this;
    SerialKind.call(this);
  }
  var ENUM_instance;
  function ENUM_getInstance() {
    if (ENUM_instance == null)
      new ENUM();
    return ENUM_instance;
  }
  function CONTEXTUAL() {
    CONTEXTUAL_instance = this;
    SerialKind.call(this);
  }
  var CONTEXTUAL_instance;
  function CONTEXTUAL_getInstance() {
    if (CONTEXTUAL_instance == null)
      new CONTEXTUAL();
    return CONTEXTUAL_instance;
  }
  function SerialKind() {
  }
  protoOf(SerialKind).toString = function () {
    return ensureNotNull(getKClassFromExpression(this).o());
  };
  protoOf(SerialKind).hashCode = function () {
    return getStringHashCode(this.toString());
  };
  function BOOLEAN() {
    BOOLEAN_instance = this;
    PrimitiveKind.call(this);
  }
  var BOOLEAN_instance;
  function BOOLEAN_getInstance() {
    if (BOOLEAN_instance == null)
      new BOOLEAN();
    return BOOLEAN_instance;
  }
  function BYTE() {
    BYTE_instance = this;
    PrimitiveKind.call(this);
  }
  var BYTE_instance;
  function BYTE_getInstance() {
    if (BYTE_instance == null)
      new BYTE();
    return BYTE_instance;
  }
  function CHAR() {
    CHAR_instance = this;
    PrimitiveKind.call(this);
  }
  var CHAR_instance;
  function CHAR_getInstance() {
    if (CHAR_instance == null)
      new CHAR();
    return CHAR_instance;
  }
  function SHORT() {
    SHORT_instance = this;
    PrimitiveKind.call(this);
  }
  var SHORT_instance;
  function SHORT_getInstance() {
    if (SHORT_instance == null)
      new SHORT();
    return SHORT_instance;
  }
  function INT() {
    INT_instance = this;
    PrimitiveKind.call(this);
  }
  var INT_instance;
  function INT_getInstance() {
    if (INT_instance == null)
      new INT();
    return INT_instance;
  }
  function LONG() {
    LONG_instance = this;
    PrimitiveKind.call(this);
  }
  var LONG_instance;
  function LONG_getInstance() {
    if (LONG_instance == null)
      new LONG();
    return LONG_instance;
  }
  function FLOAT() {
    FLOAT_instance = this;
    PrimitiveKind.call(this);
  }
  var FLOAT_instance;
  function FLOAT_getInstance() {
    if (FLOAT_instance == null)
      new FLOAT();
    return FLOAT_instance;
  }
  function DOUBLE() {
    DOUBLE_instance = this;
    PrimitiveKind.call(this);
  }
  var DOUBLE_instance;
  function DOUBLE_getInstance() {
    if (DOUBLE_instance == null)
      new DOUBLE();
    return DOUBLE_instance;
  }
  function STRING() {
    STRING_instance = this;
    PrimitiveKind.call(this);
  }
  var STRING_instance;
  function STRING_getInstance() {
    if (STRING_instance == null)
      new STRING();
    return STRING_instance;
  }
  function PrimitiveKind() {
    SerialKind.call(this);
  }
  function CLASS() {
    CLASS_instance = this;
    StructureKind.call(this);
  }
  var CLASS_instance;
  function CLASS_getInstance() {
    if (CLASS_instance == null)
      new CLASS();
    return CLASS_instance;
  }
  function LIST() {
    LIST_instance = this;
    StructureKind.call(this);
  }
  var LIST_instance;
  function LIST_getInstance() {
    if (LIST_instance == null)
      new LIST();
    return LIST_instance;
  }
  function MAP() {
    MAP_instance = this;
    StructureKind.call(this);
  }
  var MAP_instance;
  function MAP_getInstance() {
    if (MAP_instance == null)
      new MAP();
    return MAP_instance;
  }
  function OBJECT() {
    OBJECT_instance = this;
    StructureKind.call(this);
  }
  var OBJECT_instance;
  function OBJECT_getInstance() {
    if (OBJECT_instance == null)
      new OBJECT();
    return OBJECT_instance;
  }
  function StructureKind() {
    SerialKind.call(this);
  }
  function AbstractDecoder() {
  }
  protoOf(AbstractDecoder).pl = function () {
    throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(AbstractDecoder).ql = function () {
    return true;
  };
  protoOf(AbstractDecoder).rl = function () {
    return null;
  };
  protoOf(AbstractDecoder).sl = function () {
    var tmp = this.pl();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).tl = function () {
    var tmp = this.pl();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).ul = function () {
    var tmp = this.pl();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).vl = function () {
    var tmp = this.pl();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).wl = function () {
    var tmp = this.pl();
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).xl = function () {
    var tmp = this.pl();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).yl = function () {
    var tmp = this.pl();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).zl = function () {
    var tmp = this.pl();
    return tmp instanceof Char ? tmp.q1_1 : THROW_CCE();
  };
  protoOf(AbstractDecoder).am = function () {
    var tmp = this.pl();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).bm = function (enumDescriptor) {
    var tmp = this.pl();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).cm = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).dm = function (deserializer, previousValue) {
    return this.em(deserializer);
  };
  protoOf(AbstractDecoder).fm = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).gm = function (descriptor) {
  };
  protoOf(AbstractDecoder).hm = function (descriptor, index) {
    return this.sl();
  };
  protoOf(AbstractDecoder).im = function (descriptor, index) {
    return this.tl();
  };
  protoOf(AbstractDecoder).jm = function (descriptor, index) {
    return this.ul();
  };
  protoOf(AbstractDecoder).km = function (descriptor, index) {
    return this.vl();
  };
  protoOf(AbstractDecoder).lm = function (descriptor, index) {
    return this.wl();
  };
  protoOf(AbstractDecoder).mm = function (descriptor, index) {
    return this.xl();
  };
  protoOf(AbstractDecoder).nm = function (descriptor, index) {
    return this.yl();
  };
  protoOf(AbstractDecoder).om = function (descriptor, index) {
    return this.zl();
  };
  protoOf(AbstractDecoder).pm = function (descriptor, index) {
    return this.am();
  };
  protoOf(AbstractDecoder).qm = function (descriptor, index) {
    return this.cm(descriptor.tk(index));
  };
  protoOf(AbstractDecoder).rm = function (descriptor, index, deserializer, previousValue) {
    return this.dm(deserializer, previousValue);
  };
  protoOf(AbstractDecoder).tm = function (descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var isNullabilitySupported = deserializer.ej().ek();
    var tmp;
    if (isNullabilitySupported || this.ql()) {
      tmp = this.dm(deserializer, previousValue);
    } else {
      tmp = this.rl();
    }
    return tmp;
  };
  function AbstractEncoder() {
  }
  protoOf(AbstractEncoder).fm = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).gm = function (descriptor) {
  };
  protoOf(AbstractEncoder).ym = function (descriptor, index) {
    return true;
  };
  protoOf(AbstractEncoder).zm = function (value) {
    throw SerializationException_init_$Create$_0('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
  };
  protoOf(AbstractEncoder).an = function () {
    throw SerializationException_init_$Create$_0("'null' is not supported by default");
  };
  protoOf(AbstractEncoder).bn = function (value) {
    return this.zm(value);
  };
  protoOf(AbstractEncoder).cn = function (value) {
    return this.zm(value);
  };
  protoOf(AbstractEncoder).dn = function (value) {
    return this.zm(value);
  };
  protoOf(AbstractEncoder).en = function (value) {
    return this.zm(value);
  };
  protoOf(AbstractEncoder).fn = function (value) {
    return this.zm(value);
  };
  protoOf(AbstractEncoder).gn = function (value) {
    return this.zm(value);
  };
  protoOf(AbstractEncoder).hn = function (value) {
    return this.zm(value);
  };
  protoOf(AbstractEncoder).in = function (value) {
    return this.zm(new Char(value));
  };
  protoOf(AbstractEncoder).jn = function (value) {
    return this.zm(value);
  };
  protoOf(AbstractEncoder).kn = function (enumDescriptor, index) {
    return this.zm(index);
  };
  protoOf(AbstractEncoder).ln = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).mn = function (descriptor, index, value) {
    if (this.ym(descriptor, index)) {
      this.bn(value);
    }
  };
  protoOf(AbstractEncoder).nn = function (descriptor, index, value) {
    if (this.ym(descriptor, index)) {
      this.cn(value);
    }
  };
  protoOf(AbstractEncoder).on = function (descriptor, index, value) {
    if (this.ym(descriptor, index)) {
      this.dn(value);
    }
  };
  protoOf(AbstractEncoder).pn = function (descriptor, index, value) {
    if (this.ym(descriptor, index)) {
      this.en(value);
    }
  };
  protoOf(AbstractEncoder).qn = function (descriptor, index, value) {
    if (this.ym(descriptor, index)) {
      this.fn(value);
    }
  };
  protoOf(AbstractEncoder).rn = function (descriptor, index, value) {
    if (this.ym(descriptor, index)) {
      this.gn(value);
    }
  };
  protoOf(AbstractEncoder).sn = function (descriptor, index, value) {
    if (this.ym(descriptor, index)) {
      this.hn(value);
    }
  };
  protoOf(AbstractEncoder).tn = function (descriptor, index, value) {
    if (this.ym(descriptor, index)) {
      this.in(value);
    }
  };
  protoOf(AbstractEncoder).un = function (descriptor, index, value) {
    if (this.ym(descriptor, index)) {
      this.jn(value);
    }
  };
  protoOf(AbstractEncoder).vn = function (descriptor, index) {
    return this.ym(descriptor, index) ? this.ln(descriptor.tk(index)) : NoOpEncoder_getInstance();
  };
  protoOf(AbstractEncoder).wn = function (descriptor, index, serializer, value) {
    if (this.ym(descriptor, index)) {
      this.xn(serializer, value);
    }
  };
  protoOf(AbstractEncoder).yn = function (descriptor, index, serializer, value) {
    if (this.ym(descriptor, index)) {
      this.zn(serializer, value);
    }
  };
  function Decoder() {
  }
  function CompositeDecoder() {
  }
  function Encoder() {
  }
  function CompositeEncoder() {
  }
  function decodeSequentially_0($this, compositeDecoder) {
    var klassName = compositeDecoder.pm($this.ej(), 0);
    var serializer = findPolymorphicSerializer($this, compositeDecoder, klassName);
    return compositeDecoder.sm($this.ej(), 1, serializer);
  }
  function AbstractPolymorphicSerializer() {
  }
  protoOf(AbstractPolymorphicSerializer).wj = function (encoder, value) {
    var actualSerializer = findPolymorphicSerializer_0(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.ej();
    var composite = encoder.fm(descriptor);
    composite.un(this.ej(), 0, actualSerializer.ej().lk());
    var tmp = this.ej();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var tmp$ret$2 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.wn(tmp, 1, tmp$ret$2, value);
    composite.gm(descriptor);
  };
  protoOf(AbstractPolymorphicSerializer).fj = function (encoder, value) {
    return this.wj(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(AbstractPolymorphicSerializer).gj = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.ej();
    var composite = decoder.fm(descriptor);
    var tmp$ret$1;
    $l$block: {
      var klassName = null;
      var value = null;
      if (composite.vm()) {
        tmp$ret$1 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.wm(this.ej());
        switch (index) {
          case -1:
            break mainLoop;
          case 0:
            klassName = composite.pm(this.ej(), index);
            break;
          case 1:
            var tmp0 = klassName;
            var tmp$ret$2;
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (tmp0 == null) {
                var message = 'Cannot read polymorphic value before its type token';
                throw IllegalArgumentException_init_$Create$(toString(message));
              } else {
                tmp$ret$2 = tmp0;
                break $l$block_0;
              }
            }

            klassName = tmp$ret$2;
            var serializer = findPolymorphicSerializer(this, composite, klassName);
            value = composite.sm(this.ej(), index, serializer);
            break;
          default:
            var tmp0_elvis_lhs = klassName;
            throw SerializationException_init_$Create$_0('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
        }
      }
      var tmp0_0 = value;
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0_0 == null) {
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException_init_$Create$(toString(message_0));
        } else {
          tmp$ret$4 = tmp0_0;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$1 = !(tmp == null) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$1;
    composite.gm(descriptor);
    return result;
  };
  protoOf(AbstractPolymorphicSerializer).hj = function (decoder, klassName) {
    return decoder.um().do(this.ij(), klassName);
  };
  protoOf(AbstractPolymorphicSerializer).jj = function (encoder, value) {
    return encoder.um().eo(this.ij(), value);
  };
  function throwSubtypeNotRegistered(subClassName, baseClass) {
    var scope = "in the polymorphic scope of '" + baseClass.o() + "'";
    throw SerializationException_init_$Create$_0(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.o() + "' has to be sealed and '@Serializable'."));
  }
  function throwSubtypeNotRegistered_0(subClass, baseClass) {
    var tmp0_elvis_lhs = subClass.o();
    throwSubtypeNotRegistered(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
  }
  function NothingSerializer_0() {
    NothingSerializer_instance = this;
    this.fo_1 = NothingSerialDescriptor_getInstance();
  }
  protoOf(NothingSerializer_0).ej = function () {
    return this.fo_1;
  };
  protoOf(NothingSerializer_0).go = function (encoder, value) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' cannot be serialized");
  };
  protoOf(NothingSerializer_0).fj = function (encoder, value) {
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.go(encoder, tmp);
  };
  protoOf(NothingSerializer_0).gj = function (decoder) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' does not have instances");
  };
  var NothingSerializer_instance;
  function NothingSerializer_getInstance() {
    if (NothingSerializer_instance == null)
      new NothingSerializer_0();
    return NothingSerializer_instance;
  }
  function DurationSerializer() {
    DurationSerializer_instance = this;
    this.ho_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
  }
  protoOf(DurationSerializer).ej = function () {
    return this.ho_1;
  };
  protoOf(DurationSerializer).io = function (encoder, value) {
    encoder.jn(Duration__toIsoString_impl_9h6wsm(value));
  };
  protoOf(DurationSerializer).fj = function (encoder, value) {
    return this.io(encoder, value instanceof Duration ? value.ig_1 : THROW_CCE());
  };
  protoOf(DurationSerializer).jo = function (decoder) {
    return Companion_getInstance().jg(decoder.am());
  };
  protoOf(DurationSerializer).gj = function (decoder) {
    return new Duration(this.jo(decoder));
  };
  var DurationSerializer_instance;
  function DurationSerializer_getInstance() {
    if (DurationSerializer_instance == null)
      new DurationSerializer();
    return DurationSerializer_instance;
  }
  function UuidSerializer() {
    UuidSerializer_instance = this;
    this.ko_1 = new PrimitiveSerialDescriptor_0('kotlin.uuid.Uuid', STRING_getInstance());
  }
  protoOf(UuidSerializer).ej = function () {
    return this.ko_1;
  };
  protoOf(UuidSerializer).lo = function (encoder, value) {
    encoder.jn(value.toString());
  };
  protoOf(UuidSerializer).fj = function (encoder, value) {
    return this.lo(encoder, value instanceof Uuid ? value : THROW_CCE());
  };
  protoOf(UuidSerializer).gj = function (decoder) {
    return Companion_getInstance_0().hh(decoder.am());
  };
  var UuidSerializer_instance;
  function UuidSerializer_getInstance() {
    if (UuidSerializer_instance == null)
      new UuidSerializer();
    return UuidSerializer_instance;
  }
  function CachedNames() {
  }
  function ArrayListClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayListClassDesc).lk = function () {
    return 'kotlin.collections.ArrayList';
  };
  function HashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(HashSetClassDesc).lk = function () {
    return 'kotlin.collections.HashSet';
  };
  function LinkedHashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(LinkedHashSetClassDesc).lk = function () {
    return 'kotlin.collections.LinkedHashSet';
  };
  function HashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
  }
  function LinkedHashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
  function ArrayClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayClassDesc).lk = function () {
    return 'kotlin.Array';
  };
  function ListLikeDescriptor(elementDescriptor) {
    this.oo_1 = elementDescriptor;
    this.po_1 = 1;
  }
  protoOf(ListLikeDescriptor).mk = function () {
    return LIST_getInstance();
  };
  protoOf(ListLikeDescriptor).ok = function () {
    return this.po_1;
  };
  protoOf(ListLikeDescriptor).qk = function (index) {
    return index.toString();
  };
  protoOf(ListLikeDescriptor).rk = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ListLikeDescriptor).uk = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.lk() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(ListLikeDescriptor).sk = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.lk() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(ListLikeDescriptor).tk = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.lk() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.oo_1;
  };
  protoOf(ListLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.oo_1, other.oo_1) && this.lk() === other.lk())
      return true;
    return false;
  };
  protoOf(ListLikeDescriptor).hashCode = function () {
    return imul(hashCode(this.oo_1), 31) + getStringHashCode(this.lk()) | 0;
  };
  protoOf(ListLikeDescriptor).toString = function () {
    return this.lk() + '(' + toString(this.oo_1) + ')';
  };
  function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
    this.uo_1 = serialName;
    this.vo_1 = keyDescriptor;
    this.wo_1 = valueDescriptor;
    this.xo_1 = 2;
  }
  protoOf(MapLikeDescriptor).lk = function () {
    return this.uo_1;
  };
  protoOf(MapLikeDescriptor).mk = function () {
    return MAP_getInstance();
  };
  protoOf(MapLikeDescriptor).ok = function () {
    return this.xo_1;
  };
  protoOf(MapLikeDescriptor).qk = function (index) {
    return index.toString();
  };
  protoOf(MapLikeDescriptor).rk = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).uk = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.lk() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(MapLikeDescriptor).sk = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.lk() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(MapLikeDescriptor).tk = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.lk() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var tmp;
    switch (index % 2 | 0) {
      case 0:
        tmp = this.vo_1;
        break;
      case 1:
        tmp = this.wo_1;
        break;
      default:
        // Inline function 'kotlin.error' call

        var message_0 = 'Unreached';
        throw IllegalStateException_init_$Create$(toString(message_0));
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    if (!(this.lk() === other.lk()))
      return false;
    if (!equals(this.vo_1, other.vo_1))
      return false;
    if (!equals(this.wo_1, other.wo_1))
      return false;
    return true;
  };
  protoOf(MapLikeDescriptor).hashCode = function () {
    var result = getStringHashCode(this.lk());
    result = imul(31, result) + hashCode(this.vo_1) | 0;
    result = imul(31, result) + hashCode(this.wo_1) | 0;
    return result;
  };
  protoOf(MapLikeDescriptor).toString = function () {
    return this.lk() + '(' + toString(this.vo_1) + ', ' + toString(this.wo_1) + ')';
  };
  function PrimitiveArrayDescriptor(primitive) {
    ListLikeDescriptor.call(this, primitive);
    this.cp_1 = primitive.lk() + 'Array';
  }
  protoOf(PrimitiveArrayDescriptor).lk = function () {
    return this.cp_1;
  };
  function ArrayListSerializer(element) {
    CollectionSerializer.call(this, element);
    this.ep_1 = new ArrayListClassDesc(element.ej());
  }
  protoOf(ArrayListSerializer).ej = function () {
    return this.ep_1;
  };
  protoOf(ArrayListSerializer).fp = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ArrayListSerializer).gp = function (_this__u8e3s4) {
    return _this__u8e3s4.z();
  };
  protoOf(ArrayListSerializer).hp = function (_this__u8e3s4) {
    return this.gp(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).ip = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(ArrayListSerializer).jp = function (_this__u8e3s4) {
    return this.ip(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).kp = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(ArrayListSerializer).lp = function (_this__u8e3s4) {
    return this.kp((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).mp = function (_this__u8e3s4, size) {
    return _this__u8e3s4.t4(size);
  };
  protoOf(ArrayListSerializer).np = function (_this__u8e3s4, size) {
    return this.mp(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ArrayListSerializer).op = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.a4(index, element);
  };
  protoOf(ArrayListSerializer).pp = function (_this__u8e3s4, index, element) {
    return this.op(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), index, element);
  };
  function HashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.aq_1 = new HashSetClassDesc(eSerializer.ej());
  }
  protoOf(HashSetSerializer).ej = function () {
    return this.aq_1;
  };
  protoOf(HashSetSerializer).fp = function () {
    return HashSet_init_$Create$();
  };
  protoOf(HashSetSerializer).bq = function (_this__u8e3s4) {
    return _this__u8e3s4.z();
  };
  protoOf(HashSetSerializer).hp = function (_this__u8e3s4) {
    return this.bq(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).cq = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashSetSerializer).jp = function (_this__u8e3s4) {
    return this.cq(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).dq = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashSetSerializer).lp = function (_this__u8e3s4) {
    return this.dq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).eq = function (_this__u8e3s4, size) {
  };
  protoOf(HashSetSerializer).np = function (_this__u8e3s4, size) {
    return this.eq(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(HashSetSerializer).fq = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.x(element);
  };
  protoOf(HashSetSerializer).pp = function (_this__u8e3s4, index, element) {
    return this.fq(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), index, element);
  };
  function LinkedHashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.hq_1 = new LinkedHashSetClassDesc(eSerializer.ej());
  }
  protoOf(LinkedHashSetSerializer).ej = function () {
    return this.hq_1;
  };
  protoOf(LinkedHashSetSerializer).fp = function () {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet_init_$Create$();
  };
  protoOf(LinkedHashSetSerializer).iq = function (_this__u8e3s4) {
    return _this__u8e3s4.z();
  };
  protoOf(LinkedHashSetSerializer).hp = function (_this__u8e3s4) {
    return this.iq(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).jq = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashSetSerializer).jp = function (_this__u8e3s4) {
    return this.jq(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).dq = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashSetSerializer).lp = function (_this__u8e3s4) {
    return this.dq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).kq = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashSetSerializer).np = function (_this__u8e3s4, size) {
    return this.kq(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(LinkedHashSetSerializer).lq = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.x(element);
  };
  protoOf(LinkedHashSetSerializer).pp = function (_this__u8e3s4, index, element) {
    return this.lq(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), index, element);
  };
  function HashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.oq_1 = new HashMapClassDesc(kSerializer.ej(), vSerializer.ej());
  }
  protoOf(HashMapSerializer).ej = function () {
    return this.oq_1;
  };
  protoOf(HashMapSerializer).pq = function (_this__u8e3s4) {
    return _this__u8e3s4.z();
  };
  protoOf(HashMapSerializer).qq = function (_this__u8e3s4) {
    return this.pq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).rq = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.l2().t();
  };
  protoOf(HashMapSerializer).sq = function (_this__u8e3s4) {
    return this.rq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).fp = function () {
    return HashMap_init_$Create$();
  };
  protoOf(HashMapSerializer).tq = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.z(), 2);
  };
  protoOf(HashMapSerializer).hp = function (_this__u8e3s4) {
    return this.tq(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).uq = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashMapSerializer).jp = function (_this__u8e3s4) {
    return this.uq(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).vq = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashMapSerializer).lp = function (_this__u8e3s4) {
    return this.vq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).wq = function (_this__u8e3s4, size) {
  };
  protoOf(HashMapSerializer).np = function (_this__u8e3s4, size) {
    return this.wq(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function LinkedHashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.dr_1 = new LinkedHashMapClassDesc(kSerializer.ej(), vSerializer.ej());
  }
  protoOf(LinkedHashMapSerializer).ej = function () {
    return this.dr_1;
  };
  protoOf(LinkedHashMapSerializer).pq = function (_this__u8e3s4) {
    return _this__u8e3s4.z();
  };
  protoOf(LinkedHashMapSerializer).qq = function (_this__u8e3s4) {
    return this.pq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).rq = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.l2().t();
  };
  protoOf(LinkedHashMapSerializer).sq = function (_this__u8e3s4) {
    return this.rq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).fp = function () {
    return LinkedHashMap_init_$Create$();
  };
  protoOf(LinkedHashMapSerializer).er = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.z(), 2);
  };
  protoOf(LinkedHashMapSerializer).hp = function (_this__u8e3s4) {
    return this.er(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).fr = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashMapSerializer).jp = function (_this__u8e3s4) {
    return this.fr(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).vq = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashMapSerializer).lp = function (_this__u8e3s4) {
    return this.vq((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).gr = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashMapSerializer).np = function (_this__u8e3s4, size) {
    return this.gr(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function ReferenceArraySerializer(kClass, eSerializer) {
    CollectionLikeSerializer.call(this, eSerializer);
    this.ir_1 = kClass;
    this.jr_1 = new ArrayClassDesc(eSerializer.ej());
  }
  protoOf(ReferenceArraySerializer).ej = function () {
    return this.jr_1;
  };
  protoOf(ReferenceArraySerializer).kr = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ReferenceArraySerializer).qq = function (_this__u8e3s4) {
    return this.kr((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).lr = function (_this__u8e3s4) {
    return arrayIterator(_this__u8e3s4);
  };
  protoOf(ReferenceArraySerializer).sq = function (_this__u8e3s4) {
    return this.lr((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).fp = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ReferenceArraySerializer).mr = function (_this__u8e3s4) {
    return _this__u8e3s4.z();
  };
  protoOf(ReferenceArraySerializer).hp = function (_this__u8e3s4) {
    return this.mr(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).nr = function (_this__u8e3s4) {
    return toNativeArrayImpl(_this__u8e3s4, this.ir_1);
  };
  protoOf(ReferenceArraySerializer).jp = function (_this__u8e3s4) {
    return this.nr(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).or = function (_this__u8e3s4) {
    return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
  };
  protoOf(ReferenceArraySerializer).lp = function (_this__u8e3s4) {
    return this.or((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).pr = function (_this__u8e3s4, size) {
    return _this__u8e3s4.t4(size);
  };
  protoOf(ReferenceArraySerializer).np = function (_this__u8e3s4, size) {
    return this.pr(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ReferenceArraySerializer).qr = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.a4(index, element);
  };
  protoOf(ReferenceArraySerializer).pp = function (_this__u8e3s4, index, element) {
    return this.qr(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), index, element);
  };
  function CollectionSerializer(element) {
    CollectionLikeSerializer.call(this, element);
  }
  protoOf(CollectionSerializer).rp = function (_this__u8e3s4) {
    return _this__u8e3s4.z();
  };
  protoOf(CollectionSerializer).qq = function (_this__u8e3s4) {
    return this.rp((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CollectionSerializer).sp = function (_this__u8e3s4) {
    return _this__u8e3s4.t();
  };
  protoOf(CollectionSerializer).sq = function (_this__u8e3s4) {
    return this.sp((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  function MapLikeSerializer(keySerializer, valueSerializer) {
    AbstractCollectionSerializer.call(this);
    this.xq_1 = keySerializer;
    this.yq_1 = valueSerializer;
  }
  protoOf(MapLikeSerializer).zq = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    if (!(size >= 0)) {
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var progression = step(until(0, imul(size, 2)), 2);
    var inductionVariable = progression.j1_1;
    var last = progression.k1_1;
    var step_0 = progression.l1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.ar(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last));
  };
  protoOf(MapLikeSerializer).vp = function (decoder, builder, startIndex, size) {
    return this.zq(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
  };
  protoOf(MapLikeSerializer).ar = function (decoder, index, builder, checkIndex) {
    var key = decoder.sm(this.ej(), index, this.xq_1);
    var tmp;
    if (checkIndex) {
      // Inline function 'kotlin.also' call
      var this_0 = decoder.wm(this.ej());
      // Inline function 'kotlin.require' call
      if (!(this_0 === (index + 1 | 0))) {
        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      tmp = this_0;
    } else {
      tmp = index + 1 | 0;
    }
    var vIndex = tmp;
    var tmp_0;
    var tmp_1;
    if (builder.g2(key)) {
      var tmp_2 = this.yq_1.ej().mk();
      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = decoder.rm(this.ej(), vIndex, this.yq_1, getValue(builder, key));
    } else {
      tmp_0 = decoder.sm(this.ej(), vIndex, this.yq_1);
    }
    var value = tmp_0;
    // Inline function 'kotlin.collections.set' call
    builder.m2(key, value);
  };
  protoOf(MapLikeSerializer).wp = function (decoder, index, builder, checkIndex) {
    return this.ar(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(MapLikeSerializer).up = function (encoder, value) {
    var size = this.qq(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.ej();
    var composite = encoder.bo(descriptor, size);
    var iterator = this.sq(value);
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = iterator;
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.component1' call
      var k = element.e2();
      // Inline function 'kotlin.collections.component2' call
      var v = element.f2();
      var tmp = this.ej();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      composite.wn(tmp, _unary__edvuaz, this.xq_1, k);
      var tmp_0 = this.ej();
      var _unary__edvuaz_0 = index;
      index = _unary__edvuaz_0 + 1 | 0;
      composite.wn(tmp_0, _unary__edvuaz_0, this.yq_1, v);
    }
    composite.gm(descriptor);
  };
  protoOf(MapLikeSerializer).fj = function (encoder, value) {
    return this.up(encoder, value);
  };
  function CollectionLikeSerializer(elementSerializer) {
    AbstractCollectionSerializer.call(this);
    this.tp_1 = elementSerializer;
  }
  protoOf(CollectionLikeSerializer).up = function (encoder, value) {
    var size = this.qq(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.ej();
    var composite = encoder.bo(descriptor, size);
    var iterator = this.sq(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.wn(this.ej(), index, this.tp_1, iterator.v());
      }
       while (inductionVariable < size);
    composite.gm(descriptor);
  };
  protoOf(CollectionLikeSerializer).fj = function (encoder, value) {
    return this.up(encoder, value);
  };
  protoOf(CollectionLikeSerializer).vp = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    if (!(size >= 0)) {
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.wp(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  };
  protoOf(CollectionLikeSerializer).wp = function (decoder, index, builder, checkIndex) {
    this.pp(builder, index, decoder.sm(this.ej(), index, this.tp_1));
  };
  function readSize($this, decoder, builder) {
    var size = decoder.xm($this.ej());
    $this.np(builder, size);
    return size;
  }
  function AbstractCollectionSerializer() {
  }
  protoOf(AbstractCollectionSerializer).yp = function (decoder, previous) {
    var tmp1_elvis_lhs = previous == null ? null : this.lp(previous);
    var builder = tmp1_elvis_lhs == null ? this.fp() : tmp1_elvis_lhs;
    var startIndex = this.hp(builder);
    var compositeDecoder = decoder.fm(this.ej());
    if (compositeDecoder.vm()) {
      this.vp(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.wm(this.ej());
        if (index === -1)
          break $l$loop;
        this.xp(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.gm(this.ej());
    return this.jp(builder);
  };
  protoOf(AbstractCollectionSerializer).gj = function (decoder) {
    return this.yp(decoder, null);
  };
  protoOf(AbstractCollectionSerializer).xp = function (decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.wp(decoder, index, builder, checkIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.wp.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  };
  function PrimitiveArraySerializer(primitiveSerializer) {
    CollectionLikeSerializer.call(this, primitiveSerializer);
    this.sr_1 = new PrimitiveArrayDescriptor(primitiveSerializer.ej());
  }
  protoOf(PrimitiveArraySerializer).ej = function () {
    return this.sr_1;
  };
  protoOf(PrimitiveArraySerializer).tr = function (_this__u8e3s4) {
    return _this__u8e3s4.ur();
  };
  protoOf(PrimitiveArraySerializer).hp = function (_this__u8e3s4) {
    return this.tr(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).vr = function (_this__u8e3s4) {
    return _this__u8e3s4.wr();
  };
  protoOf(PrimitiveArraySerializer).jp = function (_this__u8e3s4) {
    return this.vr(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).xr = function (_this__u8e3s4, size) {
    return _this__u8e3s4.yr(size);
  };
  protoOf(PrimitiveArraySerializer).np = function (_this__u8e3s4, size) {
    return this.xr(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(PrimitiveArraySerializer).zr = function (_this__u8e3s4) {
    // Inline function 'kotlin.error' call
    var message = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(PrimitiveArraySerializer).sq = function (_this__u8e3s4) {
    return this.zr(_this__u8e3s4);
  };
  protoOf(PrimitiveArraySerializer).as = function (_this__u8e3s4, index, element) {
    // Inline function 'kotlin.error' call
    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(PrimitiveArraySerializer).pp = function (_this__u8e3s4, index, element) {
    return this.as(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), index, element);
  };
  protoOf(PrimitiveArraySerializer).fp = function () {
    return this.lp(this.bs());
  };
  protoOf(PrimitiveArraySerializer).es = function (encoder, value) {
    var size = this.qq(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.sr_1;
    var composite = encoder.bo(descriptor, size);
    this.ds(composite, value, size);
    composite.gm(descriptor);
  };
  protoOf(PrimitiveArraySerializer).fj = function (encoder, value) {
    return this.es(encoder, value);
  };
  protoOf(PrimitiveArraySerializer).up = function (encoder, value) {
    return this.es(encoder, value);
  };
  protoOf(PrimitiveArraySerializer).gj = function (decoder) {
    return this.yp(decoder, null);
  };
  function PrimitiveArrayBuilder() {
  }
  protoOf(PrimitiveArrayBuilder).fs = function (requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.ur() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.yr(requiredCapacity);
      tmp = Unit_instance;
    } else {
      tmp = $super.yr.call(this, requiredCapacity);
    }
    return tmp;
  };
  function Companion() {
    Companion_instance_0 = this;
    this.gs_1 = longArray(0);
  }
  var Companion_instance_0;
  function Companion_getInstance_7() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function prepareHighMarksArray($this, elementsCount) {
    var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
    var elementsInLastSlot = elementsCount & 63;
    var highMarks = longArray(slotsCount);
    if (!(elementsInLastSlot === 0)) {
      highMarks[get_lastIndex(highMarks)] = shiftLeft(new Long(-1, -1), elementsCount);
    }
    return highMarks;
  }
  function markHigh($this, index) {
    var slot = (index >>> 6 | 0) - 1 | 0;
    var offsetInSlot = index & 63;
    $this.ks_1[slot] = bitwiseOr($this.ks_1[slot], shiftLeft(new Long(1, 0), offsetInSlot));
  }
  function nextUnmarkedHighIndex($this) {
    var inductionVariable = 0;
    var last = $this.ks_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var slot = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var slotOffset = imul(slot + 1 | 0, 64);
        var slotMarks = $this.ks_1[slot];
        while (!equalsLong(slotMarks, new Long(-1, -1))) {
          var indexInSlot = countTrailingZeroBits(invert(slotMarks));
          slotMarks = bitwiseOr(slotMarks, shiftLeft(new Long(1, 0), indexInSlot));
          var index = slotOffset + indexInSlot | 0;
          if ($this.is_1($this.hs_1, index)) {
            $this.ks_1[slot] = slotMarks;
            return index;
          }
        }
        $this.ks_1[slot] = slotMarks;
      }
       while (inductionVariable <= last);
    return -1;
  }
  function ElementMarker(descriptor, readIfAbsent) {
    Companion_getInstance_7();
    this.hs_1 = descriptor;
    this.is_1 = readIfAbsent;
    var elementsCount = this.hs_1.ok();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      if (elementsCount === 64) {
        tmp_0 = new Long(0, 0);
      } else {
        tmp_0 = shiftLeft(new Long(-1, -1), elementsCount);
      }
      tmp.js_1 = tmp_0;
      this.ks_1 = Companion_getInstance_7().gs_1;
    } else {
      this.js_1 = new Long(0, 0);
      this.ks_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  protoOf(ElementMarker).ls = function (index) {
    if (index < 64) {
      this.js_1 = bitwiseOr(this.js_1, shiftLeft(new Long(1, 0), index));
    } else {
      markHigh(this, index);
    }
  };
  protoOf(ElementMarker).ms = function () {
    var elementsCount = this.hs_1.ok();
    while (!equalsLong(this.js_1, new Long(-1, -1))) {
      var index = countTrailingZeroBits(invert(this.js_1));
      this.js_1 = bitwiseOr(this.js_1, shiftLeft(new Long(1, 0), index));
      if (this.is_1(this.hs_1, index)) {
        return index;
      }
    }
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    return -1;
  };
  function createSimpleEnumSerializer(serialName, values) {
    return new EnumSerializer(serialName, values);
  }
  function createUnmarkedDescriptor($this, serialName) {
    var d = new EnumDescriptor(serialName, $this.ns_1.length);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.ns_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      d.ct(element.s2_1);
    }
    return d;
  }
  function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
    return function () {
      var tmp0_elvis_lhs = this$0.os_1;
      return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
    };
  }
  function EnumSerializer$_get_descriptor_$ref_j67dlw() {
    return constructCallableReference(function (p0) {
      return p0.ej();
    }, 1, 0, 3);
  }
  function EnumSerializer(serialName, values) {
    this.ns_1 = values;
    this.os_1 = null;
    var tmp = this;
    tmp.ps_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda(this, serialName));
  }
  protoOf(EnumSerializer).ej = function () {
    var tmp0 = this.ps_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, EnumSerializer$_get_descriptor_$ref_j67dlw(), null);
    return tmp0.f2();
  };
  protoOf(EnumSerializer).dt = function (encoder, value) {
    var index = indexOf(this.ns_1, value);
    if (index === -1) {
      throw SerializationException_init_$Create$_0(toString(value) + ' is not a valid enum ' + this.ej().lk() + ', ' + ('must be one of ' + contentToString(this.ns_1)));
    }
    encoder.kn(this.ej(), index);
  };
  protoOf(EnumSerializer).fj = function (encoder, value) {
    return this.dt(encoder, value instanceof Enum ? value : THROW_CCE());
  };
  protoOf(EnumSerializer).gj = function (decoder) {
    var index = decoder.bm(this.ej());
    if (!(0 <= index ? index <= (this.ns_1.length - 1 | 0) : false)) {
      throw SerializationException_init_$Create$_0('' + index + ' is not among valid ' + this.ej().lk() + ' enum values, ' + ('values size is ' + this.ns_1.length));
    }
    return this.ns_1[index];
  };
  protoOf(EnumSerializer).toString = function () {
    return 'kotlinx.serialization.internal.EnumSerializer<' + this.ej().lk() + '>';
  };
  function _get_elementDescriptors__y23q9p($this) {
    var tmp0 = $this.rt_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('elementDescriptors', 1, tmp, EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a(), null);
    return tmp0.f2();
  }
  function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
    return function () {
      var tmp = 0;
      var tmp_0 = $elementsCount;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = Array(tmp_0);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.qk(tmp_2), OBJECT_getInstance(), []);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a() {
    return constructCallableReference(function (p0) {
      return _get_elementDescriptors__y23q9p(p0);
    }, 1, 0, 4);
  }
  function EnumDescriptor(name, elementsCount) {
    PluginGeneratedSerialDescriptor.call(this, name, VOID, elementsCount);
    this.qt_1 = ENUM_getInstance();
    var tmp = this;
    tmp.rt_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
  }
  protoOf(EnumDescriptor).mk = function () {
    return this.qt_1;
  };
  protoOf(EnumDescriptor).tk = function (index) {
    return getChecked(_get_elementDescriptors__y23q9p(this), index);
  };
  protoOf(EnumDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
      return false;
    if (!(other.mk() === ENUM_getInstance()))
      return false;
    if (!(this.lk() === other.lk()))
      return false;
    if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
      return false;
    return true;
  };
  protoOf(EnumDescriptor).toString = function () {
    return joinToString(get_elementNames(this), ', ', this.lk() + '(', ')');
  };
  protoOf(EnumDescriptor).hashCode = function () {
    var result = getStringHashCode(this.lk());
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var _iterator__ex2g4s = get_elementNames(this).t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var elementsHashCode = accumulator;
    result = imul(31, result) + elementsHashCode | 0;
    return result;
  };
  function InlinePrimitiveDescriptor(name, primitiveSerializer) {
    return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
  }
  function InlineClassDescriptor(name, generatedSerializer) {
    PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
    this.gu_1 = true;
  }
  protoOf(InlineClassDescriptor).nk = function () {
    return this.gu_1;
  };
  protoOf(InlineClassDescriptor).hashCode = function () {
    return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
  };
  protoOf(InlineClassDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.lk() === other.lk())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(other.gu_1 && contentEquals(this.st(), other.st()))) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ok() === other.ok())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.ok();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.tk(index).lk() === other.tk(index).lk())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.tk(index).mk(), other.tk(index).mk())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  function InlinePrimitiveDescriptor$1($primitiveSerializer) {
    this.hu_1 = $primitiveSerializer;
  }
  protoOf(InlinePrimitiveDescriptor$1).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.hu_1];
  };
  protoOf(InlinePrimitiveDescriptor$1).ej = function () {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).fj = function (encoder, value) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).gj = function (decoder) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  function jsonCachedSerialNames(_this__u8e3s4) {
    return cachedSerialNames(_this__u8e3s4);
  }
  function NoOpEncoder() {
    NoOpEncoder_instance = this;
    AbstractEncoder.call(this);
    this.ku_1 = EmptySerializersModule_0();
  }
  protoOf(NoOpEncoder).um = function () {
    return this.ku_1;
  };
  protoOf(NoOpEncoder).zm = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).an = function () {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).bn = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).cn = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).dn = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).en = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).fn = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).gn = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).hn = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).in = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).jn = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).kn = function (enumDescriptor, index) {
    return Unit_instance;
  };
  var NoOpEncoder_instance;
  function NoOpEncoder_getInstance() {
    if (NoOpEncoder_instance == null)
      new NoOpEncoder();
    return NoOpEncoder_instance;
  }
  function error($this) {
    throw IllegalStateException_init_$Create$('Descriptor for type `kotlin.Nothing` does not have elements');
  }
  function NothingSerialDescriptor() {
    NothingSerialDescriptor_instance = this;
    this.lu_1 = OBJECT_getInstance();
    this.mu_1 = 'kotlin.Nothing';
  }
  protoOf(NothingSerialDescriptor).mk = function () {
    return this.lu_1;
  };
  protoOf(NothingSerialDescriptor).lk = function () {
    return this.mu_1;
  };
  protoOf(NothingSerialDescriptor).ok = function () {
    return 0;
  };
  protoOf(NothingSerialDescriptor).qk = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).rk = function (name) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).uk = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).tk = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).sk = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).toString = function () {
    return 'NothingSerialDescriptor';
  };
  protoOf(NothingSerialDescriptor).equals = function (other) {
    return this === other;
  };
  protoOf(NothingSerialDescriptor).hashCode = function () {
    return getStringHashCode(this.mu_1) + imul(31, this.lu_1.hashCode()) | 0;
  };
  var NothingSerialDescriptor_instance;
  function NothingSerialDescriptor_getInstance() {
    if (NothingSerialDescriptor_instance == null)
      new NothingSerialDescriptor();
    return NothingSerialDescriptor_instance;
  }
  function NullableSerializer(serializer) {
    this.nu_1 = serializer;
    this.ou_1 = new SerialDescriptorForNullable(this.nu_1.ej());
  }
  protoOf(NullableSerializer).ej = function () {
    return this.ou_1;
  };
  protoOf(NullableSerializer).pu = function (encoder, value) {
    if (!(value == null)) {
      encoder.ao();
      encoder.xn(this.nu_1, value);
    } else {
      encoder.an();
    }
  };
  protoOf(NullableSerializer).fj = function (encoder, value) {
    return this.pu(encoder, value);
  };
  protoOf(NullableSerializer).gj = function (decoder) {
    return decoder.ql() ? decoder.em(this.nu_1) : decoder.rl();
  };
  protoOf(NullableSerializer).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NullableSerializer))
      THROW_CCE();
    if (!equals(this.nu_1, other.nu_1))
      return false;
    return true;
  };
  protoOf(NullableSerializer).hashCode = function () {
    return hashCode(this.nu_1);
  };
  function SerialDescriptorForNullable(original) {
    this.fk_1 = original;
    this.gk_1 = this.fk_1.lk() + '?';
    this.hk_1 = cachedSerialNames(this.fk_1);
  }
  protoOf(SerialDescriptorForNullable).lk = function () {
    return this.gk_1;
  };
  protoOf(SerialDescriptorForNullable).ol = function () {
    return this.hk_1;
  };
  protoOf(SerialDescriptorForNullable).ek = function () {
    return true;
  };
  protoOf(SerialDescriptorForNullable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    if (!equals(this.fk_1, other.fk_1))
      return false;
    return true;
  };
  protoOf(SerialDescriptorForNullable).toString = function () {
    return toString(this.fk_1) + '?';
  };
  protoOf(SerialDescriptorForNullable).hashCode = function () {
    return imul(hashCode(this.fk_1), 31);
  };
  protoOf(SerialDescriptorForNullable).mk = function () {
    return this.fk_1.mk();
  };
  protoOf(SerialDescriptorForNullable).nk = function () {
    return this.fk_1.nk();
  };
  protoOf(SerialDescriptorForNullable).ok = function () {
    return this.fk_1.ok();
  };
  protoOf(SerialDescriptorForNullable).pk = function () {
    return this.fk_1.pk();
  };
  protoOf(SerialDescriptorForNullable).qk = function (index) {
    return this.fk_1.qk(index);
  };
  protoOf(SerialDescriptorForNullable).rk = function (name) {
    return this.fk_1.rk(name);
  };
  protoOf(SerialDescriptorForNullable).sk = function (index) {
    return this.fk_1.sk(index);
  };
  protoOf(SerialDescriptorForNullable).tk = function (index) {
    return this.fk_1.tk(index);
  };
  protoOf(SerialDescriptorForNullable).uk = function (index) {
    return this.fk_1.uk(index);
  };
  function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.mj_1 = this$0.ru_1;
      return Unit_instance;
    };
  }
  function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = OBJECT_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function ObjectSerializer$_get_descriptor_$ref_7z4xb6() {
    return constructCallableReference(function (p0) {
      return p0.ej();
    }, 1, 0, 5);
  }
  function ObjectSerializer(serialName, objectInstance) {
    this.qu_1 = objectInstance;
    this.ru_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.su_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
  }
  protoOf(ObjectSerializer).ej = function () {
    var tmp0 = this.su_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, ObjectSerializer$_get_descriptor_$ref_7z4xb6(), null);
    return tmp0.f2();
  };
  protoOf(ObjectSerializer).wj = function (encoder, value) {
    encoder.fm(this.ej()).gm(this.ej());
  };
  protoOf(ObjectSerializer).fj = function (encoder, value) {
    return this.wj(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(ObjectSerializer).gj = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.ej();
    var composite = decoder.fm(descriptor);
    var tmp$ret$1;
    $l$block_0: {
      if (composite.vm()) {
        tmp$ret$1 = Unit_instance;
        break $l$block_0;
      }
      var index = composite.wm(this.ej());
      if (index === -1) {
        tmp$ret$1 = Unit_instance;
        break $l$block_0;
      } else
        throw SerializationException_init_$Create$_0('Unexpected index ' + index);
    }
    var result = tmp$ret$1;
    composite.gm(descriptor);
    return this.qu_1;
  };
  function get_EMPTY_DESCRIPTOR_ARRAY() {
    _init_properties_Platform_common_kt__3qzecs();
    return EMPTY_DESCRIPTOR_ARRAY;
  }
  var EMPTY_DESCRIPTOR_ARRAY;
  function kclass(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var t = _this__u8e3s4.j();
    var tmp;
    if (!(t == null) ? isInterface(t, KClass) : false) {
      tmp = t;
    } else {
      if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
        throw IllegalArgumentException_init_$Create$('Captured type parameter ' + toString(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported because ' + toString(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString(t) + '.'));
      } else {
        throw IllegalArgumentException_init_$Create$('Only KClass supported as classifier, got ' + toString_0(t));
      }
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
  }
  function typeOrThrow(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp0 = _this__u8e3s4.if_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Star projections in type arguments are not allowed, but had ' + toString_0(_this__u8e3s4.if_1);
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$0;
  }
  function compactArray(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    // Inline function 'kotlin.takeUnless' call
    var tmp;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (!(_this__u8e3s4 == null || _this__u8e3s4.r())) {
      tmp = _this__u8e3s4;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
  }
  function cachedSerialNames(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    if (isInterface(_this__u8e3s4, CachedNames))
      return _this__u8e3s4.ol();
    var result = HashSet_init_$Create$_1(_this__u8e3s4.ok());
    var inductionVariable = 0;
    var last = _this__u8e3s4.ok();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = _this__u8e3s4.qk(i);
        result.x(element);
      }
       while (inductionVariable < last);
    return result;
  }
  function notRegisteredMessage(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp0_elvis_lhs = _this__u8e3s4.o();
    return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
  }
  function notRegisteredMessage_0(className) {
    _init_properties_Platform_common_kt__3qzecs();
    return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
  }
  var properties_initialized_Platform_common_kt_i7q4ty;
  function _init_properties_Platform_common_kt__3qzecs() {
    if (!properties_initialized_Platform_common_kt_i7q4ty) {
      properties_initialized_Platform_common_kt_i7q4ty = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_DESCRIPTOR_ARRAY = [];
    }
  }
  function throwMissingFieldException(seen, goldenMask, descriptor) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var missingFields = ArrayList_init_$Create$_0();
    var missingFieldsBits = goldenMask & ~seen;
    var inductionVariable = 0;
    if (inductionVariable < 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!((missingFieldsBits & 1) === 0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          var element = descriptor.qk(i);
          missingFields.x(element);
        }
        missingFieldsBits = missingFieldsBits >>> 1 | 0;
      }
       while (inductionVariable < 32);
    throw MissingFieldException_init_$Create$(missingFields, descriptor.lk());
  }
  function hashCodeImpl(_this__u8e3s4, typeParams) {
    var result = getStringHashCode(_this__u8e3s4.lk());
    result = imul(31, result) + contentHashCode(typeParams) | 0;
    var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var _iterator__ex2g4s = elementDescriptors.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = element.lk();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var namesHash = accumulator;
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator_0 = 1;
    var _iterator__ex2g4s_0 = elementDescriptors.t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      var hash_0 = accumulator_0;
      var tmp_0 = imul(31, hash_0);
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver_0 = element_0.mk();
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
      accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    }
    var kindHash = accumulator_0;
    result = imul(31, result) + namesHash | 0;
    result = imul(31, result) + kindHash | 0;
    return result;
  }
  function _get_childSerializers__7vnyfa($this) {
    var tmp0 = $this.zs_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('childSerializers', 1, tmp, PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca(), null);
    return tmp0.f2();
  }
  function _get__hashCode__tgwhef_0($this) {
    var tmp0 = $this.bt_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('_hashCode', 1, tmp, PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz(), null);
    return tmp0.f2();
  }
  function buildIndices($this) {
    var indices = HashMap_init_$Create$();
    var inductionVariable = 0;
    var last = $this.us_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var key = $this.us_1[i];
        indices.m2(key, i);
      }
       while (inductionVariable <= last);
    return indices;
  }
  function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.rs_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.iu();
      return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
    };
  }
  function PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca() {
    return constructCallableReference(function (p0) {
      return _get_childSerializers__7vnyfa(p0);
    }, 1, 0, 6);
  }
  function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.rs_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ju();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(tmp1_safe_receiver.length);
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$2 = item.ej();
          destination.x(tmp$ret$2);
        }
        tmp = destination;
      }
      return compactArray(tmp);
    };
  }
  function PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka() {
    return constructCallableReference(function (p0) {
      return p0.st();
    }, 1, 0, 7);
  }
  function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.st());
    };
  }
  function PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz() {
    return constructCallableReference(function (p0) {
      return _get__hashCode__tgwhef_0(p0);
    }, 1, 0, 8);
  }
  function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
    return function (i) {
      return this$0.qk(i) + ': ' + this$0.tk(i).lk();
    };
  }
  function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.qs_1 = serialName;
    this.rs_1 = generatedSerializer;
    this.ss_1 = elementsCount;
    this.ts_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.ss_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.us_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.ss_1;
    tmp_3.vs_1 = Array(size);
    this.ws_1 = null;
    this.xs_1 = booleanArray(this.ss_1);
    this.ys_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.zs_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.at_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.bt_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  protoOf(PluginGeneratedSerialDescriptor).lk = function () {
    return this.qs_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).ok = function () {
    return this.ss_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).mk = function () {
    return CLASS_getInstance();
  };
  protoOf(PluginGeneratedSerialDescriptor).pk = function () {
    var tmp0_elvis_lhs = this.ws_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).ol = function () {
    return this.ys_1.j2();
  };
  protoOf(PluginGeneratedSerialDescriptor).st = function () {
    var tmp0 = this.at_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('typeParameterDescriptors', 1, tmp, PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka(), null);
    return tmp0.f2();
  };
  protoOf(PluginGeneratedSerialDescriptor).tt = function (name, isOptional) {
    this.ts_1 = this.ts_1 + 1 | 0;
    this.us_1[this.ts_1] = name;
    this.xs_1[this.ts_1] = isOptional;
    this.vs_1[this.ts_1] = null;
    if (this.ts_1 === (this.ss_1 - 1 | 0)) {
      this.ys_1 = buildIndices(this);
    }
  };
  protoOf(PluginGeneratedSerialDescriptor).ct = function (name, isOptional, $super) {
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.tt(name, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.tt.call(this, name, isOptional);
    }
    return tmp;
  };
  protoOf(PluginGeneratedSerialDescriptor).tk = function (index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).ej();
  };
  protoOf(PluginGeneratedSerialDescriptor).uk = function (index) {
    return getChecked_0(this.xs_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).sk = function (index) {
    var tmp0_elvis_lhs = getChecked(this.vs_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).qk = function (index) {
    return getChecked(this.us_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).rk = function (name) {
    var tmp0_elvis_lhs = this.ys_1.i2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.lk() === other.lk())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!contentEquals(this.st(), other.st())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ok() === other.ok())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.ok();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.tk(index).lk() === other.tk(index).lk())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.tk(index).mk(), other.tk(index).mk())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
    return _get__hashCode__tgwhef_0(this);
  };
  protoOf(PluginGeneratedSerialDescriptor).toString = function () {
    var tmp = until(0, this.ss_1);
    var tmp_0 = this.lk() + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
  };
  function get_EMPTY_SERIALIZER_ARRAY() {
    _init_properties_PluginHelperInterfaces_kt__xgvzfp();
    return EMPTY_SERIALIZER_ARRAY;
  }
  var EMPTY_SERIALIZER_ARRAY;
  function SerializerFactory() {
  }
  function GeneratedSerializer() {
  }
  var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
  function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
    if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
      properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_SERIALIZER_ARRAY = [];
    }
  }
  function CharArraySerializer_0() {
    CharArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_9(Companion_getInstance_1()));
  }
  protoOf(CharArraySerializer_0).wu = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(CharArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.wu((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).xu = function (_this__u8e3s4) {
    return new CharArrayBuilder(_this__u8e3s4);
  };
  protoOf(CharArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.xu((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).bs = function () {
    return charArray(0);
  };
  protoOf(CharArraySerializer_0).yu = function (decoder, index, builder, checkIndex) {
    builder.bv(decoder.om(this.sr_1, index));
  };
  protoOf(CharArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.yu(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.yu(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).cv = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.tn(this.sr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(CharArraySerializer_0).ds = function (encoder, content, size) {
    return this.cv(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
  };
  var CharArraySerializer_instance;
  function CharArraySerializer_getInstance() {
    if (CharArraySerializer_instance == null)
      new CharArraySerializer_0();
    return CharArraySerializer_instance;
  }
  function DoubleArraySerializer_0() {
    DoubleArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_10(DoubleCompanionObject_instance));
  }
  protoOf(DoubleArraySerializer_0).fv = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(DoubleArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.fv((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).gv = function (_this__u8e3s4) {
    return new DoubleArrayBuilder(_this__u8e3s4);
  };
  protoOf(DoubleArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.gv((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).bs = function () {
    return new Float64Array(0);
  };
  protoOf(DoubleArraySerializer_0).hv = function (decoder, index, builder, checkIndex) {
    builder.kv(decoder.nm(this.sr_1, index));
  };
  protoOf(DoubleArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.hv(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.hv(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).lv = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.sn(this.sr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(DoubleArraySerializer_0).ds = function (encoder, content, size) {
    return this.lv(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
  };
  var DoubleArraySerializer_instance;
  function DoubleArraySerializer_getInstance() {
    if (DoubleArraySerializer_instance == null)
      new DoubleArraySerializer_0();
    return DoubleArraySerializer_instance;
  }
  function FloatArraySerializer_0() {
    FloatArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_11(FloatCompanionObject_instance));
  }
  protoOf(FloatArraySerializer_0).ov = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(FloatArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.ov((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).pv = function (_this__u8e3s4) {
    return new FloatArrayBuilder(_this__u8e3s4);
  };
  protoOf(FloatArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.pv((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).bs = function () {
    return new Float32Array(0);
  };
  protoOf(FloatArraySerializer_0).qv = function (decoder, index, builder, checkIndex) {
    builder.tv(decoder.mm(this.sr_1, index));
  };
  protoOf(FloatArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.qv(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.qv(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).uv = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.rn(this.sr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(FloatArraySerializer_0).ds = function (encoder, content, size) {
    return this.uv(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
  };
  var FloatArraySerializer_instance;
  function FloatArraySerializer_getInstance() {
    if (FloatArraySerializer_instance == null)
      new FloatArraySerializer_0();
    return FloatArraySerializer_instance;
  }
  function LongArraySerializer_0() {
    LongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_5(Companion_getInstance_2()));
  }
  protoOf(LongArraySerializer_0).xv = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(LongArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.xv((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).yv = function (_this__u8e3s4) {
    return new LongArrayBuilder(_this__u8e3s4);
  };
  protoOf(LongArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.yv((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).bs = function () {
    return longArray(0);
  };
  protoOf(LongArraySerializer_0).zv = function (decoder, index, builder, checkIndex) {
    builder.cw(decoder.lm(this.sr_1, index));
  };
  protoOf(LongArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.zv(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.zv(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).dw = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.qn(this.sr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(LongArraySerializer_0).ds = function (encoder, content, size) {
    return this.dw(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
  };
  var LongArraySerializer_instance;
  function LongArraySerializer_getInstance() {
    if (LongArraySerializer_instance == null)
      new LongArraySerializer_0();
    return LongArraySerializer_instance;
  }
  function ULongArraySerializer_0() {
    ULongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_1(Companion_getInstance_3()));
  }
  protoOf(ULongArraySerializer_0).gw = function (_this__u8e3s4) {
    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.gw(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.pi_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).hw = function (_this__u8e3s4) {
    return new ULongArrayBuilder(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.hw(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.pi_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).iw = function () {
    return _ULongArray___init__impl__twm1l3(0);
  };
  protoOf(ULongArraySerializer_0).bs = function () {
    return new ULongArray(this.iw());
  };
  protoOf(ULongArraySerializer_0).jw = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.qm(this.sr_1, index).wl();
    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
    builder.mw(tmp$ret$0);
  };
  protoOf(ULongArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.jw(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.jw(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).nw = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.vn(this.sr_1, i);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = ULongArray__get_impl_pr71q9(content, i);
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        tmp.fn(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(ULongArraySerializer_0).ds = function (encoder, content, size) {
    return this.nw(encoder, content instanceof ULongArray ? content.pi_1 : THROW_CCE(), size);
  };
  var ULongArraySerializer_instance;
  function ULongArraySerializer_getInstance() {
    if (ULongArraySerializer_instance == null)
      new ULongArraySerializer_0();
    return ULongArraySerializer_instance;
  }
  function IntArraySerializer_0() {
    IntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_6(IntCompanionObject_instance));
  }
  protoOf(IntArraySerializer_0).qw = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(IntArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.qw((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).rw = function (_this__u8e3s4) {
    return new IntArrayBuilder(_this__u8e3s4);
  };
  protoOf(IntArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.rw((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).bs = function () {
    return new Int32Array(0);
  };
  protoOf(IntArraySerializer_0).sw = function (decoder, index, builder, checkIndex) {
    builder.vw(decoder.km(this.sr_1, index));
  };
  protoOf(IntArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.sw(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.sw(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).ww = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.pn(this.sr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(IntArraySerializer_0).ds = function (encoder, content, size) {
    return this.ww(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
  };
  var IntArraySerializer_instance;
  function IntArraySerializer_getInstance() {
    if (IntArraySerializer_instance == null)
      new IntArraySerializer_0();
    return IntArraySerializer_instance;
  }
  function UIntArraySerializer_0() {
    UIntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_2(Companion_getInstance_4()));
  }
  protoOf(UIntArraySerializer_0).zw = function (_this__u8e3s4) {
    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.zw(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.fi_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).ax = function (_this__u8e3s4) {
    return new UIntArrayBuilder(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.ax(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.fi_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).bx = function () {
    return _UIntArray___init__impl__ghjpc6(0);
  };
  protoOf(UIntArraySerializer_0).bs = function () {
    return new UIntArray(this.bx());
  };
  protoOf(UIntArraySerializer_0).cx = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.qm(this.sr_1, index).vl();
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
    builder.fx(tmp$ret$0);
  };
  protoOf(UIntArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.cx(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.cx(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).gx = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.vn(this.sr_1, i);
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = UIntArray__get_impl_gp5kza(content, i);
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        tmp.en(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UIntArraySerializer_0).ds = function (encoder, content, size) {
    return this.gx(encoder, content instanceof UIntArray ? content.fi_1 : THROW_CCE(), size);
  };
  var UIntArraySerializer_instance;
  function UIntArraySerializer_getInstance() {
    if (UIntArraySerializer_instance == null)
      new UIntArraySerializer_0();
    return UIntArraySerializer_instance;
  }
  function ShortArraySerializer_0() {
    ShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_8(ShortCompanionObject_instance));
  }
  protoOf(ShortArraySerializer_0).jx = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ShortArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.jx((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).kx = function (_this__u8e3s4) {
    return new ShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(ShortArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.kx((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).bs = function () {
    return new Int16Array(0);
  };
  protoOf(ShortArraySerializer_0).lx = function (decoder, index, builder, checkIndex) {
    builder.ox(decoder.jm(this.sr_1, index));
  };
  protoOf(ShortArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.lx(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.lx(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).px = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.on(this.sr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ShortArraySerializer_0).ds = function (encoder, content, size) {
    return this.px(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ShortArraySerializer_instance;
  function ShortArraySerializer_getInstance() {
    if (ShortArraySerializer_instance == null)
      new ShortArraySerializer_0();
    return ShortArraySerializer_instance;
  }
  function UShortArraySerializer_0() {
    UShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_4(Companion_getInstance_5()));
  }
  protoOf(UShortArraySerializer_0).sx = function (_this__u8e3s4) {
    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.sx(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.zi_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).tx = function (_this__u8e3s4) {
    return new UShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.tx(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.zi_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).ux = function () {
    return _UShortArray___init__impl__9b26ef(0);
  };
  protoOf(UShortArraySerializer_0).bs = function () {
    return new UShortArray(this.ux());
  };
  protoOf(UShortArraySerializer_0).vx = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.qm(this.sr_1, index).ul();
    var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
    builder.yx(tmp$ret$0);
  };
  protoOf(UShortArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.vx(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.vx(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).zx = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.vn(this.sr_1, i);
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = UShortArray__get_impl_fnbhmx(content, i);
        var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        tmp.dn(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UShortArraySerializer_0).ds = function (encoder, content, size) {
    return this.zx(encoder, content instanceof UShortArray ? content.zi_1 : THROW_CCE(), size);
  };
  var UShortArraySerializer_instance;
  function UShortArraySerializer_getInstance() {
    if (UShortArraySerializer_instance == null)
      new UShortArraySerializer_0();
    return UShortArraySerializer_instance;
  }
  function ByteArraySerializer_0() {
    ByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_7(ByteCompanionObject_instance));
  }
  protoOf(ByteArraySerializer_0).cy = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ByteArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.cy((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).dy = function (_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(ByteArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.dy((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).bs = function () {
    return new Int8Array(0);
  };
  protoOf(ByteArraySerializer_0).ey = function (decoder, index, builder, checkIndex) {
    builder.hy(decoder.im(this.sr_1, index));
  };
  protoOf(ByteArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.ey(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.ey(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).iy = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.nn(this.sr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ByteArraySerializer_0).ds = function (encoder, content, size) {
    return this.iy(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ByteArraySerializer_instance;
  function ByteArraySerializer_getInstance() {
    if (ByteArraySerializer_instance == null)
      new ByteArraySerializer_0();
    return ByteArraySerializer_instance;
  }
  function UByteArraySerializer_0() {
    UByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_3(Companion_getInstance_6()));
  }
  protoOf(UByteArraySerializer_0).ly = function (_this__u8e3s4) {
    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.ly(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.vh_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).my = function (_this__u8e3s4) {
    return new UByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.my(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.vh_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).ny = function () {
    return _UByteArray___init__impl__ip4y9n(0);
  };
  protoOf(UByteArraySerializer_0).bs = function () {
    return new UByteArray(this.ny());
  };
  protoOf(UByteArraySerializer_0).oy = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.qm(this.sr_1, index).tl();
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
    builder.ry(tmp$ret$0);
  };
  protoOf(UByteArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.oy(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.oy(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).sy = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.vn(this.sr_1, i);
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = UByteArray__get_impl_t5f3hv(content, i);
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        tmp.cn(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UByteArraySerializer_0).ds = function (encoder, content, size) {
    return this.sy(encoder, content instanceof UByteArray ? content.vh_1 : THROW_CCE(), size);
  };
  var UByteArraySerializer_instance;
  function UByteArraySerializer_getInstance() {
    if (UByteArraySerializer_instance == null)
      new UByteArraySerializer_0();
    return UByteArraySerializer_instance;
  }
  function BooleanArraySerializer_0() {
    BooleanArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_12(BooleanCompanionObject_instance));
  }
  protoOf(BooleanArraySerializer_0).vy = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(BooleanArraySerializer_0).qq = function (_this__u8e3s4) {
    return this.vy((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).wy = function (_this__u8e3s4) {
    return new BooleanArrayBuilder(_this__u8e3s4);
  };
  protoOf(BooleanArraySerializer_0).lp = function (_this__u8e3s4) {
    return this.wy((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).bs = function () {
    return booleanArray(0);
  };
  protoOf(BooleanArraySerializer_0).xy = function (decoder, index, builder, checkIndex) {
    builder.az(decoder.hm(this.sr_1, index));
  };
  protoOf(BooleanArraySerializer_0).wp = function (decoder, index, builder, checkIndex) {
    return this.xy(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).cs = function (decoder, index, builder, checkIndex) {
    return this.xy(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).bz = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.mn(this.sr_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(BooleanArraySerializer_0).ds = function (encoder, content, size) {
    return this.bz(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
  };
  var BooleanArraySerializer_instance;
  function BooleanArraySerializer_getInstance() {
    if (BooleanArraySerializer_instance == null)
      new BooleanArraySerializer_0();
    return BooleanArraySerializer_instance;
  }
  function CharArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.zu_1 = bufferWithData;
    this.av_1 = bufferWithData.length;
    this.yr(10);
  }
  protoOf(CharArrayBuilder).ur = function () {
    return this.av_1;
  };
  protoOf(CharArrayBuilder).yr = function (requiredCapacity) {
    if (this.zu_1.length < requiredCapacity)
      this.zu_1 = copyOf(this.zu_1, coerceAtLeast(requiredCapacity, imul(this.zu_1.length, 2)));
  };
  protoOf(CharArrayBuilder).bv = function (c) {
    this.fs();
    var tmp = this.zu_1;
    var _unary__edvuaz = this.av_1;
    this.av_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(CharArrayBuilder).wr = function () {
    return copyOf(this.zu_1, this.av_1);
  };
  function DoubleArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.iv_1 = bufferWithData;
    this.jv_1 = bufferWithData.length;
    this.yr(10);
  }
  protoOf(DoubleArrayBuilder).ur = function () {
    return this.jv_1;
  };
  protoOf(DoubleArrayBuilder).yr = function (requiredCapacity) {
    if (this.iv_1.length < requiredCapacity)
      this.iv_1 = copyOf_0(this.iv_1, coerceAtLeast(requiredCapacity, imul(this.iv_1.length, 2)));
  };
  protoOf(DoubleArrayBuilder).kv = function (c) {
    this.fs();
    var tmp = this.iv_1;
    var _unary__edvuaz = this.jv_1;
    this.jv_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(DoubleArrayBuilder).wr = function () {
    return copyOf_0(this.iv_1, this.jv_1);
  };
  function FloatArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.rv_1 = bufferWithData;
    this.sv_1 = bufferWithData.length;
    this.yr(10);
  }
  protoOf(FloatArrayBuilder).ur = function () {
    return this.sv_1;
  };
  protoOf(FloatArrayBuilder).yr = function (requiredCapacity) {
    if (this.rv_1.length < requiredCapacity)
      this.rv_1 = copyOf_1(this.rv_1, coerceAtLeast(requiredCapacity, imul(this.rv_1.length, 2)));
  };
  protoOf(FloatArrayBuilder).tv = function (c) {
    this.fs();
    var tmp = this.rv_1;
    var _unary__edvuaz = this.sv_1;
    this.sv_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(FloatArrayBuilder).wr = function () {
    return copyOf_1(this.rv_1, this.sv_1);
  };
  function LongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.aw_1 = bufferWithData;
    this.bw_1 = bufferWithData.length;
    this.yr(10);
  }
  protoOf(LongArrayBuilder).ur = function () {
    return this.bw_1;
  };
  protoOf(LongArrayBuilder).yr = function (requiredCapacity) {
    if (this.aw_1.length < requiredCapacity)
      this.aw_1 = copyOf_2(this.aw_1, coerceAtLeast(requiredCapacity, imul(this.aw_1.length, 2)));
  };
  protoOf(LongArrayBuilder).cw = function (c) {
    this.fs();
    var tmp = this.aw_1;
    var _unary__edvuaz = this.bw_1;
    this.bw_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(LongArrayBuilder).wr = function () {
    return copyOf_2(this.aw_1, this.bw_1);
  };
  function ULongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.kw_1 = bufferWithData;
    this.lw_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
    this.yr(10);
  }
  protoOf(ULongArrayBuilder).ur = function () {
    return this.lw_1;
  };
  protoOf(ULongArrayBuilder).yr = function (requiredCapacity) {
    if (_ULongArray___get_size__impl__ju6dtr(this.kw_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.kw_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.kw_1), 2));
      tmp.kw_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
    }
  };
  protoOf(ULongArrayBuilder).mw = function (c) {
    this.fs();
    var tmp = this.kw_1;
    var _unary__edvuaz = this.lw_1;
    this.lw_1 = _unary__edvuaz + 1 | 0;
    ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
  };
  protoOf(ULongArrayBuilder).cz = function () {
    var tmp0 = this.kw_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.lw_1;
    return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
  };
  protoOf(ULongArrayBuilder).wr = function () {
    return new ULongArray(this.cz());
  };
  function IntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.tw_1 = bufferWithData;
    this.uw_1 = bufferWithData.length;
    this.yr(10);
  }
  protoOf(IntArrayBuilder).ur = function () {
    return this.uw_1;
  };
  protoOf(IntArrayBuilder).yr = function (requiredCapacity) {
    if (this.tw_1.length < requiredCapacity)
      this.tw_1 = copyOf_3(this.tw_1, coerceAtLeast(requiredCapacity, imul(this.tw_1.length, 2)));
  };
  protoOf(IntArrayBuilder).vw = function (c) {
    this.fs();
    var tmp = this.tw_1;
    var _unary__edvuaz = this.uw_1;
    this.uw_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(IntArrayBuilder).wr = function () {
    return copyOf_3(this.tw_1, this.uw_1);
  };
  function UIntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.dx_1 = bufferWithData;
    this.ex_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
    this.yr(10);
  }
  protoOf(UIntArrayBuilder).ur = function () {
    return this.ex_1;
  };
  protoOf(UIntArrayBuilder).yr = function (requiredCapacity) {
    if (_UIntArray___get_size__impl__r6l8ci(this.dx_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.dx_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.dx_1), 2));
      tmp.dx_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
    }
  };
  protoOf(UIntArrayBuilder).fx = function (c) {
    this.fs();
    var tmp = this.dx_1;
    var _unary__edvuaz = this.ex_1;
    this.ex_1 = _unary__edvuaz + 1 | 0;
    UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
  };
  protoOf(UIntArrayBuilder).dz = function () {
    var tmp0 = this.dx_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.ex_1;
    return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
  };
  protoOf(UIntArrayBuilder).wr = function () {
    return new UIntArray(this.dz());
  };
  function ShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.mx_1 = bufferWithData;
    this.nx_1 = bufferWithData.length;
    this.yr(10);
  }
  protoOf(ShortArrayBuilder).ur = function () {
    return this.nx_1;
  };
  protoOf(ShortArrayBuilder).yr = function (requiredCapacity) {
    if (this.mx_1.length < requiredCapacity)
      this.mx_1 = copyOf_4(this.mx_1, coerceAtLeast(requiredCapacity, imul(this.mx_1.length, 2)));
  };
  protoOf(ShortArrayBuilder).ox = function (c) {
    this.fs();
    var tmp = this.mx_1;
    var _unary__edvuaz = this.nx_1;
    this.nx_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(ShortArrayBuilder).wr = function () {
    return copyOf_4(this.mx_1, this.nx_1);
  };
  function UShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.wx_1 = bufferWithData;
    this.xx_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
    this.yr(10);
  }
  protoOf(UShortArrayBuilder).ur = function () {
    return this.xx_1;
  };
  protoOf(UShortArrayBuilder).yr = function (requiredCapacity) {
    if (_UShortArray___get_size__impl__jqto1b(this.wx_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.wx_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.wx_1), 2));
      tmp.wx_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
    }
  };
  protoOf(UShortArrayBuilder).yx = function (c) {
    this.fs();
    var tmp = this.wx_1;
    var _unary__edvuaz = this.xx_1;
    this.xx_1 = _unary__edvuaz + 1 | 0;
    UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
  };
  protoOf(UShortArrayBuilder).ez = function () {
    var tmp0 = this.wx_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.xx_1;
    return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
  };
  protoOf(UShortArrayBuilder).wr = function () {
    return new UShortArray(this.ez());
  };
  function ByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.fy_1 = bufferWithData;
    this.gy_1 = bufferWithData.length;
    this.yr(10);
  }
  protoOf(ByteArrayBuilder).ur = function () {
    return this.gy_1;
  };
  protoOf(ByteArrayBuilder).yr = function (requiredCapacity) {
    if (this.fy_1.length < requiredCapacity)
      this.fy_1 = copyOf_5(this.fy_1, coerceAtLeast(requiredCapacity, imul(this.fy_1.length, 2)));
  };
  protoOf(ByteArrayBuilder).hy = function (c) {
    this.fs();
    var tmp = this.fy_1;
    var _unary__edvuaz = this.gy_1;
    this.gy_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(ByteArrayBuilder).wr = function () {
    return copyOf_5(this.fy_1, this.gy_1);
  };
  function UByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.py_1 = bufferWithData;
    this.qy_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
    this.yr(10);
  }
  protoOf(UByteArrayBuilder).ur = function () {
    return this.qy_1;
  };
  protoOf(UByteArrayBuilder).yr = function (requiredCapacity) {
    if (_UByteArray___get_size__impl__h6pkdv(this.py_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.py_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.py_1), 2));
      tmp.py_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
    }
  };
  protoOf(UByteArrayBuilder).ry = function (c) {
    this.fs();
    var tmp = this.py_1;
    var _unary__edvuaz = this.qy_1;
    this.qy_1 = _unary__edvuaz + 1 | 0;
    UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
  };
  protoOf(UByteArrayBuilder).fz = function () {
    var tmp0 = this.py_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.qy_1;
    return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
  };
  protoOf(UByteArrayBuilder).wr = function () {
    return new UByteArray(this.fz());
  };
  function BooleanArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.yy_1 = bufferWithData;
    this.zy_1 = bufferWithData.length;
    this.yr(10);
  }
  protoOf(BooleanArrayBuilder).ur = function () {
    return this.zy_1;
  };
  protoOf(BooleanArrayBuilder).yr = function (requiredCapacity) {
    if (this.yy_1.length < requiredCapacity)
      this.yy_1 = copyOf_6(this.yy_1, coerceAtLeast(requiredCapacity, imul(this.yy_1.length, 2)));
  };
  protoOf(BooleanArrayBuilder).az = function (c) {
    this.fs();
    var tmp = this.yy_1;
    var _unary__edvuaz = this.zy_1;
    this.zy_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(BooleanArrayBuilder).wr = function () {
    return copyOf_6(this.yy_1, this.zy_1);
  };
  function get_BUILTIN_SERIALIZERS() {
    _init_properties_Primitives_kt__k0eto4();
    return BUILTIN_SERIALIZERS;
  }
  var BUILTIN_SERIALIZERS;
  function builtinSerializerOrNull(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    var tmp = get_BUILTIN_SERIALIZERS().i2(_this__u8e3s4);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
  }
  function StringSerializer() {
    StringSerializer_instance = this;
    this.gz_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
  }
  protoOf(StringSerializer).ej = function () {
    return this.gz_1;
  };
  protoOf(StringSerializer).hz = function (encoder, value) {
    return encoder.jn(value);
  };
  protoOf(StringSerializer).fj = function (encoder, value) {
    return this.hz(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(StringSerializer).gj = function (decoder) {
    return decoder.am();
  };
  var StringSerializer_instance;
  function StringSerializer_getInstance() {
    if (StringSerializer_instance == null)
      new StringSerializer();
    return StringSerializer_instance;
  }
  function PrimitiveDescriptorSafe(serialName, kind) {
    _init_properties_Primitives_kt__k0eto4();
    checkNameIsNotAPrimitive(serialName);
    return new PrimitiveSerialDescriptor_0(serialName, kind);
  }
  function error_0($this) {
    throw IllegalStateException_init_$Create$('Primitive descriptor ' + $this.iz_1 + ' does not have elements');
  }
  function PrimitiveSerialDescriptor_0(serialName, kind) {
    this.iz_1 = serialName;
    this.jz_1 = kind;
  }
  protoOf(PrimitiveSerialDescriptor_0).lk = function () {
    return this.iz_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).mk = function () {
    return this.jz_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).ok = function () {
    return 0;
  };
  protoOf(PrimitiveSerialDescriptor_0).qk = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).rk = function (name) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).uk = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).tk = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).sk = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).toString = function () {
    return 'PrimitiveDescriptor(' + this.iz_1 + ')';
  };
  protoOf(PrimitiveSerialDescriptor_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor_0))
      return false;
    if (this.iz_1 === other.iz_1 && equals(this.jz_1, other.jz_1))
      return true;
    return false;
  };
  protoOf(PrimitiveSerialDescriptor_0).hashCode = function () {
    return getStringHashCode(this.iz_1) + imul(31, this.jz_1.hashCode()) | 0;
  };
  function checkNameIsNotAPrimitive(serialName) {
    _init_properties_Primitives_kt__k0eto4();
    var values = get_BUILTIN_SERIALIZERS().k2();
    var _iterator__ex2g4s = values.t();
    while (_iterator__ex2g4s.u()) {
      var primitive = _iterator__ex2g4s.v();
      var primitiveName = primitive.ej().lk();
      if (serialName === primitiveName) {
        throw IllegalArgumentException_init_$Create$(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).o() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
      }
    }
  }
  function LongSerializer() {
    LongSerializer_instance = this;
    this.kz_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
  }
  protoOf(LongSerializer).ej = function () {
    return this.kz_1;
  };
  protoOf(LongSerializer).lz = function (encoder, value) {
    return encoder.fn(value);
  };
  protoOf(LongSerializer).fj = function (encoder, value) {
    return this.lz(encoder, value instanceof Long ? value : THROW_CCE());
  };
  protoOf(LongSerializer).gj = function (decoder) {
    return decoder.wl();
  };
  var LongSerializer_instance;
  function LongSerializer_getInstance() {
    if (LongSerializer_instance == null)
      new LongSerializer();
    return LongSerializer_instance;
  }
  function IntSerializer() {
    IntSerializer_instance = this;
    this.mz_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
  }
  protoOf(IntSerializer).ej = function () {
    return this.mz_1;
  };
  protoOf(IntSerializer).nz = function (encoder, value) {
    return encoder.en(value);
  };
  protoOf(IntSerializer).fj = function (encoder, value) {
    return this.nz(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(IntSerializer).gj = function (decoder) {
    return decoder.vl();
  };
  var IntSerializer_instance;
  function IntSerializer_getInstance() {
    if (IntSerializer_instance == null)
      new IntSerializer();
    return IntSerializer_instance;
  }
  function ByteSerializer() {
    ByteSerializer_instance = this;
    this.oz_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
  }
  protoOf(ByteSerializer).ej = function () {
    return this.oz_1;
  };
  protoOf(ByteSerializer).pz = function (encoder, value) {
    return encoder.cn(value);
  };
  protoOf(ByteSerializer).fj = function (encoder, value) {
    return this.pz(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ByteSerializer).gj = function (decoder) {
    return decoder.tl();
  };
  var ByteSerializer_instance;
  function ByteSerializer_getInstance() {
    if (ByteSerializer_instance == null)
      new ByteSerializer();
    return ByteSerializer_instance;
  }
  function ShortSerializer() {
    ShortSerializer_instance = this;
    this.qz_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
  }
  protoOf(ShortSerializer).ej = function () {
    return this.qz_1;
  };
  protoOf(ShortSerializer).rz = function (encoder, value) {
    return encoder.dn(value);
  };
  protoOf(ShortSerializer).fj = function (encoder, value) {
    return this.rz(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ShortSerializer).gj = function (decoder) {
    return decoder.ul();
  };
  var ShortSerializer_instance;
  function ShortSerializer_getInstance() {
    if (ShortSerializer_instance == null)
      new ShortSerializer();
    return ShortSerializer_instance;
  }
  function CharSerializer() {
    CharSerializer_instance = this;
    this.sz_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
  }
  protoOf(CharSerializer).ej = function () {
    return this.sz_1;
  };
  protoOf(CharSerializer).tz = function (encoder, value) {
    return encoder.in(value);
  };
  protoOf(CharSerializer).fj = function (encoder, value) {
    return this.tz(encoder, value instanceof Char ? value.q1_1 : THROW_CCE());
  };
  protoOf(CharSerializer).uz = function (decoder) {
    return decoder.zl();
  };
  protoOf(CharSerializer).gj = function (decoder) {
    return new Char(this.uz(decoder));
  };
  var CharSerializer_instance;
  function CharSerializer_getInstance() {
    if (CharSerializer_instance == null)
      new CharSerializer();
    return CharSerializer_instance;
  }
  function DoubleSerializer() {
    DoubleSerializer_instance = this;
    this.vz_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
  }
  protoOf(DoubleSerializer).ej = function () {
    return this.vz_1;
  };
  protoOf(DoubleSerializer).wz = function (encoder, value) {
    return encoder.hn(value);
  };
  protoOf(DoubleSerializer).fj = function (encoder, value) {
    return this.wz(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(DoubleSerializer).gj = function (decoder) {
    return decoder.yl();
  };
  var DoubleSerializer_instance;
  function DoubleSerializer_getInstance() {
    if (DoubleSerializer_instance == null)
      new DoubleSerializer();
    return DoubleSerializer_instance;
  }
  function FloatSerializer() {
    FloatSerializer_instance = this;
    this.xz_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
  }
  protoOf(FloatSerializer).ej = function () {
    return this.xz_1;
  };
  protoOf(FloatSerializer).yz = function (encoder, value) {
    return encoder.gn(value);
  };
  protoOf(FloatSerializer).fj = function (encoder, value) {
    return this.yz(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(FloatSerializer).gj = function (decoder) {
    return decoder.xl();
  };
  var FloatSerializer_instance;
  function FloatSerializer_getInstance() {
    if (FloatSerializer_instance == null)
      new FloatSerializer();
    return FloatSerializer_instance;
  }
  function BooleanSerializer() {
    BooleanSerializer_instance = this;
    this.zz_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
  }
  protoOf(BooleanSerializer).ej = function () {
    return this.zz_1;
  };
  protoOf(BooleanSerializer).a10 = function (encoder, value) {
    return encoder.bn(value);
  };
  protoOf(BooleanSerializer).fj = function (encoder, value) {
    return this.a10(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  protoOf(BooleanSerializer).gj = function (decoder) {
    return decoder.sl();
  };
  var BooleanSerializer_instance;
  function BooleanSerializer_getInstance() {
    if (BooleanSerializer_instance == null)
      new BooleanSerializer();
    return BooleanSerializer_instance;
  }
  function UnitSerializer() {
    UnitSerializer_instance = this;
    this.b10_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
  }
  protoOf(UnitSerializer).ej = function () {
    return this.b10_1.ej();
  };
  protoOf(UnitSerializer).c10 = function (encoder, value) {
    this.b10_1.wj(encoder, Unit_instance);
  };
  protoOf(UnitSerializer).fj = function (encoder, value) {
    return this.c10(encoder, value instanceof Unit ? value : THROW_CCE());
  };
  protoOf(UnitSerializer).d10 = function (decoder) {
    this.b10_1.gj(decoder);
  };
  protoOf(UnitSerializer).gj = function (decoder) {
    this.d10(decoder);
    return Unit_instance;
  };
  var UnitSerializer_instance;
  function UnitSerializer_getInstance() {
    if (UnitSerializer_instance == null)
      new UnitSerializer();
    return UnitSerializer_instance;
  }
  var properties_initialized_Primitives_kt_6dpii6;
  function _init_properties_Primitives_kt__k0eto4() {
    if (!properties_initialized_Primitives_kt_6dpii6) {
      properties_initialized_Primitives_kt_6dpii6 = true;
      BUILTIN_SERIALIZERS = initBuiltins();
    }
  }
  function NamedValueDecoder() {
    TaggedDecoder.call(this);
  }
  protoOf(NamedValueDecoder).g10 = function (_this__u8e3s4, index) {
    return this.i10(this.h10(_this__u8e3s4, index));
  };
  protoOf(NamedValueDecoder).i10 = function (nestedName) {
    var tmp0_elvis_lhs = this.l10();
    return this.m10(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  protoOf(NamedValueDecoder).h10 = function (descriptor, index) {
    return descriptor.qk(index);
  };
  protoOf(NamedValueDecoder).m10 = function (parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  };
  protoOf(NamedValueDecoder).n10 = function () {
    return this.j10_1.r() ? '$' : joinToString(this.j10_1, '.', '$.');
  };
  function tagBlock($this, tag, block) {
    $this.b11(tag);
    var r = block();
    if (!$this.k10_1) {
      $this.c11();
    }
    $this.k10_1 = false;
    return r;
  }
  function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      return this$0.dm($deserializer, $previousValue);
    };
  }
  function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      var tmp0 = this$0;
      // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
      var isNullabilitySupported = $deserializer.ej().ek();
      var tmp;
      if (isNullabilitySupported || tmp0.ql()) {
        tmp = this$0.dm($deserializer, $previousValue);
      } else {
        tmp = tmp0.rl();
      }
      return tmp;
    };
  }
  function TaggedDecoder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.j10_1 = ArrayList_init_$Create$_0();
    this.k10_1 = false;
  }
  protoOf(TaggedDecoder).um = function () {
    return EmptySerializersModule_0();
  };
  protoOf(TaggedDecoder).o10 = function (tag) {
    throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(TaggedDecoder).p10 = function (tag) {
    return true;
  };
  protoOf(TaggedDecoder).q10 = function (tag) {
    var tmp = this.o10(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).r10 = function (tag) {
    var tmp = this.o10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).s10 = function (tag) {
    var tmp = this.o10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).t10 = function (tag) {
    var tmp = this.o10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).u10 = function (tag) {
    var tmp = this.o10(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).v10 = function (tag) {
    var tmp = this.o10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).w10 = function (tag) {
    var tmp = this.o10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).x10 = function (tag) {
    var tmp = this.o10(tag);
    return tmp instanceof Char ? tmp.q1_1 : THROW_CCE();
  };
  protoOf(TaggedDecoder).y10 = function (tag) {
    var tmp = this.o10(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).z10 = function (tag, enumDescriptor) {
    var tmp = this.o10(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).a11 = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    this.b11(tag);
    return this;
  };
  protoOf(TaggedDecoder).dm = function (deserializer, previousValue) {
    return this.em(deserializer);
  };
  protoOf(TaggedDecoder).cm = function (descriptor) {
    return this.a11(this.c11(), descriptor);
  };
  protoOf(TaggedDecoder).ql = function () {
    var tmp0_elvis_lhs = this.l10();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.p10(currentTag);
  };
  protoOf(TaggedDecoder).rl = function () {
    return null;
  };
  protoOf(TaggedDecoder).sl = function () {
    return this.q10(this.c11());
  };
  protoOf(TaggedDecoder).tl = function () {
    return this.r10(this.c11());
  };
  protoOf(TaggedDecoder).ul = function () {
    return this.s10(this.c11());
  };
  protoOf(TaggedDecoder).vl = function () {
    return this.t10(this.c11());
  };
  protoOf(TaggedDecoder).wl = function () {
    return this.u10(this.c11());
  };
  protoOf(TaggedDecoder).xl = function () {
    return this.v10(this.c11());
  };
  protoOf(TaggedDecoder).yl = function () {
    return this.w10(this.c11());
  };
  protoOf(TaggedDecoder).zl = function () {
    return this.x10(this.c11());
  };
  protoOf(TaggedDecoder).am = function () {
    return this.y10(this.c11());
  };
  protoOf(TaggedDecoder).bm = function (enumDescriptor) {
    return this.z10(this.c11(), enumDescriptor);
  };
  protoOf(TaggedDecoder).fm = function (descriptor) {
    return this;
  };
  protoOf(TaggedDecoder).gm = function (descriptor) {
  };
  protoOf(TaggedDecoder).hm = function (descriptor, index) {
    return this.q10(this.g10(descriptor, index));
  };
  protoOf(TaggedDecoder).im = function (descriptor, index) {
    return this.r10(this.g10(descriptor, index));
  };
  protoOf(TaggedDecoder).jm = function (descriptor, index) {
    return this.s10(this.g10(descriptor, index));
  };
  protoOf(TaggedDecoder).km = function (descriptor, index) {
    return this.t10(this.g10(descriptor, index));
  };
  protoOf(TaggedDecoder).lm = function (descriptor, index) {
    return this.u10(this.g10(descriptor, index));
  };
  protoOf(TaggedDecoder).mm = function (descriptor, index) {
    return this.v10(this.g10(descriptor, index));
  };
  protoOf(TaggedDecoder).nm = function (descriptor, index) {
    return this.w10(this.g10(descriptor, index));
  };
  protoOf(TaggedDecoder).om = function (descriptor, index) {
    return this.x10(this.g10(descriptor, index));
  };
  protoOf(TaggedDecoder).pm = function (descriptor, index) {
    return this.y10(this.g10(descriptor, index));
  };
  protoOf(TaggedDecoder).qm = function (descriptor, index) {
    return this.a11(this.g10(descriptor, index), descriptor.tk(index));
  };
  protoOf(TaggedDecoder).rm = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.g10(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).tm = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.g10(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).l10 = function () {
    return lastOrNull(this.j10_1);
  };
  protoOf(TaggedDecoder).b11 = function (name) {
    this.j10_1.x(name);
  };
  protoOf(TaggedDecoder).c11 = function () {
    var r = this.j10_1.q2(get_lastIndex_0(this.j10_1));
    this.k10_1 = true;
    return r;
  };
  function get_NULL() {
    _init_properties_Tuples_kt__dz0qyd();
    return NULL;
  }
  var NULL;
  function MapEntry(key, value) {
    this.d11_1 = key;
    this.e11_1 = value;
  }
  protoOf(MapEntry).e2 = function () {
    return this.d11_1;
  };
  protoOf(MapEntry).f2 = function () {
    return this.e11_1;
  };
  protoOf(MapEntry).toString = function () {
    return 'MapEntry(key=' + toString_0(this.d11_1) + ', value=' + toString_0(this.e11_1) + ')';
  };
  protoOf(MapEntry).hashCode = function () {
    var result = this.d11_1 == null ? 0 : hashCode(this.d11_1);
    result = imul(result, 31) + (this.e11_1 == null ? 0 : hashCode(this.e11_1)) | 0;
    return result;
  };
  protoOf(MapEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals(this.d11_1, tmp0_other_with_cast.d11_1))
      return false;
    if (!equals(this.e11_1, tmp0_other_with_cast.e11_1))
      return false;
    return true;
  };
  function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.sj('key', $keySerializer.ej());
      $this$buildSerialDescriptor.sj('value', $valueSerializer.ej());
      return Unit_instance;
    };
  }
  function MapEntrySerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.h11_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(MapEntrySerializer_0).ej = function () {
    return this.h11_1;
  };
  protoOf(MapEntrySerializer_0).i11 = function (_this__u8e3s4) {
    return _this__u8e3s4.e2();
  };
  protoOf(MapEntrySerializer_0).j11 = function (_this__u8e3s4) {
    return this.i11((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).k11 = function (_this__u8e3s4) {
    return _this__u8e3s4.f2();
  };
  protoOf(MapEntrySerializer_0).l11 = function (_this__u8e3s4) {
    return this.k11((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).m11 = function (key, value) {
    return new MapEntry(key, value);
  };
  function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.sj('first', $keySerializer.ej());
      $this$buildClassSerialDescriptor.sj('second', $valueSerializer.ej());
      return Unit_instance;
    };
  }
  function PairSerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    tmp.s11_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(PairSerializer_0).ej = function () {
    return this.s11_1;
  };
  protoOf(PairSerializer_0).t11 = function (_this__u8e3s4) {
    return _this__u8e3s4.e9_1;
  };
  protoOf(PairSerializer_0).j11 = function (_this__u8e3s4) {
    return this.t11(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).u11 = function (_this__u8e3s4) {
    return _this__u8e3s4.f9_1;
  };
  protoOf(PairSerializer_0).l11 = function (_this__u8e3s4) {
    return this.u11(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).m11 = function (key, value) {
    return to(key, value);
  };
  function decodeSequentially_1($this, composite) {
    var a = composite.sm($this.y11_1, 0, $this.v11_1);
    var b = composite.sm($this.y11_1, 1, $this.w11_1);
    var c = composite.sm($this.y11_1, 2, $this.x11_1);
    composite.gm($this.y11_1);
    return new Triple(a, b, c);
  }
  function decodeStructure($this, composite) {
    var a = get_NULL();
    var b = get_NULL();
    var c = get_NULL();
    mainLoop: while (true) {
      var index = composite.wm($this.y11_1);
      switch (index) {
        case -1:
          break mainLoop;
        case 0:
          a = composite.sm($this.y11_1, 0, $this.v11_1);
          break;
        case 1:
          b = composite.sm($this.y11_1, 1, $this.w11_1);
          break;
        case 2:
          c = composite.sm($this.y11_1, 2, $this.x11_1);
          break;
        default:
          throw SerializationException_init_$Create$_0('Unexpected index ' + index);
      }
    }
    composite.gm($this.y11_1);
    if (a === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'first' is missing");
    if (b === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'second' is missing");
    if (c === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'third' is missing");
    return new Triple(a, b, c);
  }
  function TripleSerializer$descriptor$lambda(this$0) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.sj('first', this$0.v11_1.ej());
      $this$buildClassSerialDescriptor.sj('second', this$0.w11_1.ej());
      $this$buildClassSerialDescriptor.sj('third', this$0.x11_1.ej());
      return Unit_instance;
    };
  }
  function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
    this.v11_1 = aSerializer;
    this.w11_1 = bSerializer;
    this.x11_1 = cSerializer;
    var tmp = this;
    tmp.y11_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
  }
  protoOf(TripleSerializer_0).ej = function () {
    return this.y11_1;
  };
  protoOf(TripleSerializer_0).z11 = function (encoder, value) {
    var structuredEncoder = encoder.fm(this.y11_1);
    structuredEncoder.wn(this.y11_1, 0, this.v11_1, value.eh_1);
    structuredEncoder.wn(this.y11_1, 1, this.w11_1, value.fh_1);
    structuredEncoder.wn(this.y11_1, 2, this.x11_1, value.gh_1);
    structuredEncoder.gm(this.y11_1);
  };
  protoOf(TripleSerializer_0).fj = function (encoder, value) {
    return this.z11(encoder, value instanceof Triple ? value : THROW_CCE());
  };
  protoOf(TripleSerializer_0).gj = function (decoder) {
    var composite = decoder.fm(this.y11_1);
    if (composite.vm()) {
      return decodeSequentially_1(this, composite);
    }
    return decodeStructure(this, composite);
  };
  function KeyValueSerializer(keySerializer, valueSerializer) {
    this.n11_1 = keySerializer;
    this.o11_1 = valueSerializer;
  }
  protoOf(KeyValueSerializer).p11 = function (encoder, value) {
    var structuredEncoder = encoder.fm(this.ej());
    structuredEncoder.wn(this.ej(), 0, this.n11_1, this.j11(value));
    structuredEncoder.wn(this.ej(), 1, this.o11_1, this.l11(value));
    structuredEncoder.gm(this.ej());
  };
  protoOf(KeyValueSerializer).fj = function (encoder, value) {
    return this.p11(encoder, value);
  };
  protoOf(KeyValueSerializer).gj = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.ej();
    var composite = decoder.fm(descriptor);
    var tmp$ret$1;
    $l$block: {
      if (composite.vm()) {
        var key = composite.sm(this.ej(), 0, this.n11_1);
        var value = composite.sm(this.ej(), 1, this.o11_1);
        tmp$ret$1 = this.m11(key, value);
        break $l$block;
      }
      var key_0 = get_NULL();
      var value_0 = get_NULL();
      mainLoop: while (true) {
        var idx = composite.wm(this.ej());
        switch (idx) {
          case -1:
            break mainLoop;
          case 0:
            key_0 = composite.sm(this.ej(), 0, this.n11_1);
            break;
          case 1:
            value_0 = composite.sm(this.ej(), 1, this.o11_1);
            break;
          default:
            throw SerializationException_init_$Create$_0('Invalid index: ' + idx);
        }
      }
      if (key_0 === get_NULL())
        throw SerializationException_init_$Create$_0("Element 'key' is missing");
      if (value_0 === get_NULL())
        throw SerializationException_init_$Create$_0("Element 'value' is missing");
      tmp$ret$1 = this.m11(key_0, value_0);
    }
    var result = tmp$ret$1;
    composite.gm(descriptor);
    return result;
  };
  var properties_initialized_Tuples_kt_3vs7ar;
  function _init_properties_Tuples_kt__dz0qyd() {
    if (!properties_initialized_Tuples_kt_3vs7ar) {
      properties_initialized_Tuples_kt_3vs7ar = true;
      NULL = new Object();
    }
  }
  function ULongSerializer() {
    ULongSerializer_instance = this;
    this.a12_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_5(Companion_getInstance_2()));
  }
  protoOf(ULongSerializer).ej = function () {
    return this.a12_1;
  };
  protoOf(ULongSerializer).b12 = function (encoder, value) {
    var tmp = encoder.ln(this.a12_1);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
    tmp.fn(tmp$ret$0);
  };
  protoOf(ULongSerializer).fj = function (encoder, value) {
    return this.b12(encoder, value instanceof ULong ? value.ki_1 : THROW_CCE());
  };
  protoOf(ULongSerializer).c12 = function (decoder) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.cm(this.a12_1).wl();
    return _ULong___init__impl__c78o9k(this_0);
  };
  protoOf(ULongSerializer).gj = function (decoder) {
    return new ULong(this.c12(decoder));
  };
  var ULongSerializer_instance;
  function ULongSerializer_getInstance() {
    if (ULongSerializer_instance == null)
      new ULongSerializer();
    return ULongSerializer_instance;
  }
  function UIntSerializer() {
    UIntSerializer_instance = this;
    this.d12_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_6(IntCompanionObject_instance));
  }
  protoOf(UIntSerializer).ej = function () {
    return this.d12_1;
  };
  protoOf(UIntSerializer).e12 = function (encoder, value) {
    var tmp = encoder.ln(this.d12_1);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
    tmp.en(tmp$ret$0);
  };
  protoOf(UIntSerializer).fj = function (encoder, value) {
    return this.e12(encoder, value instanceof UInt ? value.ai_1 : THROW_CCE());
  };
  protoOf(UIntSerializer).f12 = function (decoder) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.cm(this.d12_1).vl();
    return _UInt___init__impl__l7qpdl(this_0);
  };
  protoOf(UIntSerializer).gj = function (decoder) {
    return new UInt(this.f12(decoder));
  };
  var UIntSerializer_instance;
  function UIntSerializer_getInstance() {
    if (UIntSerializer_instance == null)
      new UIntSerializer();
    return UIntSerializer_instance;
  }
  function UByteSerializer() {
    UByteSerializer_instance = this;
    this.g12_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_7(ByteCompanionObject_instance));
  }
  protoOf(UByteSerializer).ej = function () {
    return this.g12_1;
  };
  protoOf(UByteSerializer).h12 = function (encoder, value) {
    var tmp = encoder.ln(this.g12_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    tmp.cn(tmp$ret$0);
  };
  protoOf(UByteSerializer).fj = function (encoder, value) {
    return this.h12(encoder, value instanceof UByte ? value.qh_1 : THROW_CCE());
  };
  protoOf(UByteSerializer).i12 = function (decoder) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.cm(this.g12_1).tl();
    return _UByte___init__impl__g9hnc4(this_0);
  };
  protoOf(UByteSerializer).gj = function (decoder) {
    return new UByte(this.i12(decoder));
  };
  var UByteSerializer_instance;
  function UByteSerializer_getInstance() {
    if (UByteSerializer_instance == null)
      new UByteSerializer();
    return UByteSerializer_instance;
  }
  function UShortSerializer() {
    UShortSerializer_instance = this;
    this.j12_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_8(ShortCompanionObject_instance));
  }
  protoOf(UShortSerializer).ej = function () {
    return this.j12_1;
  };
  protoOf(UShortSerializer).k12 = function (encoder, value) {
    var tmp = encoder.ln(this.j12_1);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
    tmp.dn(tmp$ret$0);
  };
  protoOf(UShortSerializer).fj = function (encoder, value) {
    return this.k12(encoder, value instanceof UShort ? value.ui_1 : THROW_CCE());
  };
  protoOf(UShortSerializer).l12 = function (decoder) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.cm(this.j12_1).ul();
    return _UShort___init__impl__jigrne(this_0);
  };
  protoOf(UShortSerializer).gj = function (decoder) {
    return new UShort(this.l12(decoder));
  };
  var UShortSerializer_instance;
  function UShortSerializer_getInstance() {
    if (UShortSerializer_instance == null)
      new UShortSerializer();
    return UShortSerializer_instance;
  }
  function get_EmptySerializersModuleLegacyJs() {
    _init_properties_SerializersModule_kt__u78ha3();
    return EmptySerializersModule;
  }
  var EmptySerializersModule;
  function SerializersModule() {
  }
  protoOf(SerializersModule).ak = function (kClass, typeArgumentsSerializers, $super) {
    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
    return $super === VOID ? this.bk(kClass, typeArgumentsSerializers) : $super.bk.call(this, kClass, typeArgumentsSerializers);
  };
  function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider, hasInterfaceContextualSerializers) {
    SerializersModule.call(this);
    this.n12_1 = class2ContextualFactory;
    this.o12_1 = polyBase2Serializers;
    this.p12_1 = polyBase2DefaultSerializerProvider;
    this.q12_1 = polyBase2NamedSerializers;
    this.r12_1 = polyBase2DefaultDeserializerProvider;
    this.s12_1 = hasInterfaceContextualSerializers;
  }
  protoOf(SerialModuleImpl).zj = function () {
    return this.s12_1;
  };
  protoOf(SerialModuleImpl).eo = function (baseClass, value) {
    if (!baseClass.j9(value))
      return null;
    var tmp0_safe_receiver = this.o12_1.i2(baseClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i2(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.p12_1.i2(baseClass);
    var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
  };
  protoOf(SerialModuleImpl).do = function (baseClass, serializedClassName) {
    var tmp0_safe_receiver = this.q12_1.i2(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).i2(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.r12_1.i2(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  };
  protoOf(SerialModuleImpl).bk = function (kClass, typeArgumentsSerializers) {
    var tmp0_safe_receiver = this.n12_1.i2(kClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t12(typeArgumentsSerializers);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
  };
  protoOf(SerialModuleImpl).m12 = function (collector) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.n12_1.l2().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.component1' call
      var kclass = element.e2();
      // Inline function 'kotlin.collections.component2' call
      var serial = element.f2();
      if (serial instanceof Argless) {
        var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
        var tmp_0 = serial.w12_1;
        collector.x12(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
      } else {
        if (serial instanceof WithTypeArguments) {
          collector.v12(kclass, serial.u12_1);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = this.o12_1.l2().t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      // Inline function 'kotlin.collections.component1' call
      var baseClass = element_0.e2();
      // Inline function 'kotlin.collections.component2' call
      var classMap = element_0.f2();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_1 = classMap.l2().t();
      while (_iterator__ex2g4s_1.u()) {
        var element_1 = _iterator__ex2g4s_1.v();
        // Inline function 'kotlin.collections.component1' call
        var actualClass = element_1.e2();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element_1.f2();
        var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
        var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$15 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
        collector.y12(tmp_1, tmp_2, tmp$ret$15);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_2 = this.p12_1.l2().t();
    while (_iterator__ex2g4s_2.u()) {
      var element_2 = _iterator__ex2g4s_2.v();
      // Inline function 'kotlin.collections.component1' call
      var baseClass_0 = element_2.e2();
      // Inline function 'kotlin.collections.component2' call
      var provider = element_2.f2();
      var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
      collector.z12(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_3 = this.r12_1.l2().t();
    while (_iterator__ex2g4s_3.u()) {
      var element_3 = _iterator__ex2g4s_3.v();
      // Inline function 'kotlin.collections.component1' call
      var baseClass_1 = element_3.e2();
      // Inline function 'kotlin.collections.component2' call
      var provider_0 = element_3.f2();
      var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
      collector.a13(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
    }
  };
  function Argless() {
  }
  function WithTypeArguments() {
  }
  function ContextualProvider() {
  }
  var properties_initialized_SerializersModule_kt_fjigjn;
  function _init_properties_SerializersModule_kt__u78ha3() {
    if (!properties_initialized_SerializersModule_kt_fjigjn) {
      properties_initialized_SerializersModule_kt_fjigjn = true;
      EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap(), false);
    }
  }
  function EmptySerializersModule_0() {
    return get_EmptySerializersModuleLegacyJs();
  }
  function SerializersModuleCollector$contextual$lambda($serializer) {
    return function (it) {
      return $serializer;
    };
  }
  function SerializersModuleCollector() {
  }
  function SerializableWith(serializer) {
    this.b13_1 = serializer;
  }
  protoOf(SerializableWith).equals = function (other) {
    if (!(other instanceof SerializableWith))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
    if (!this.b13_1.equals(tmp0_other_with_cast.b13_1))
      return false;
    return true;
  };
  protoOf(SerializableWith).hashCode = function () {
    return imul(getStringHashCode('serializer'), 127) ^ this.b13_1.hashCode();
  };
  protoOf(SerializableWith).toString = function () {
    return '@kotlinx.serialization.SerializableWith(' + 'serializer=' + toString(this.b13_1) + ')';
  };
  function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
  }
  function isInterface_0(_this__u8e3s4) {
    return get_isInterface(_this__u8e3s4);
  }
  function compiledSerializerImpl(_this__u8e3s4) {
    var tmp0_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      if (_this__u8e3s4 === PrimitiveClasses_getInstance().u9()) {
        tmp_0 = NothingSerializer_getInstance();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_safe_receiver = get_js(_this__u8e3s4).Companion;
        tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.serializer();
      }
      var tmp_1 = tmp_0;
      tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function isReferenceArray(rootClass) {
    return rootClass.equals(PrimitiveClasses_getInstance().ca());
  }
  function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
    var tmp;
    try {
      // Inline function 'kotlin.reflect.findAssociatedObject' call
      var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
      var tmp_0;
      if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
        tmp_0 = isInterface(assocObject, KSerializer) ? assocObject : THROW_CCE();
      } else {
        if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
          var tmp_1 = assocObject.tu(args.slice());
          tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
        } else {
          tmp_0 = null;
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      var e = $p;
      tmp_2 = null;
      tmp = tmp_2;
    }
    return tmp;
  }
  function createCache(factory) {
    return new createCache$1(factory);
  }
  function createParametrizedCache(factory) {
    return new createParametrizedCache$1(factory);
  }
  function getChecked(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function getChecked_0(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function toNativeArrayImpl(_this__u8e3s4, eClass) {
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(_this__u8e3s4);
  }
  function initBuiltins() {
    return mapOf([to(PrimitiveClasses_getInstance().da(), serializer_0(StringCompanionObject_instance)), to(getKClass(Char), serializer_9(Companion_getInstance_1())), to(PrimitiveClasses_getInstance().ga(), CharArraySerializer()), to(PrimitiveClasses_getInstance().ba(), serializer_10(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().ma(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().aa(), serializer_11(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().la(), FloatArraySerializer()), to(getKClass(Long), serializer_5(Companion_getInstance_2())), to(get_longArrayClass(), LongArraySerializer()), to(getKClass(ULong), serializer_1(Companion_getInstance_3())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().y9(), serializer_6(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().ja(), IntArraySerializer()), to(getKClass(UInt), serializer_2(Companion_getInstance_4())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().x9(), serializer_8(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().ia(), ShortArraySerializer()), to(getKClass(UShort), serializer_4(Companion_getInstance_5())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().w9(), serializer_7(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().ha(), ByteArraySerializer()), to(getKClass(UByte), serializer_3(Companion_getInstance_6())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().v9(), serializer_12(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().fa(), BooleanArraySerializer()), to(getKClass(Unit), serializer_13(Unit_instance)), to(PrimitiveClasses_getInstance().u9(), NothingSerializer()), to(getKClass(Duration), serializer_14(Companion_getInstance())), to(getKClass(Uuid), serializer_15(Companion_getInstance_0()))]);
  }
  function get_isInterface(_this__u8e3s4) {
    if (_this__u8e3s4 === PrimitiveClasses_getInstance().u9())
      return false;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
  }
  function createCache$1($factory) {
    this.c13_1 = $factory;
  }
  protoOf(createCache$1).ck = function (key) {
    return this.c13_1(key);
  };
  function createParametrizedCache$1($factory) {
    this.d13_1 = $factory;
  }
  protoOf(createParametrizedCache$1).dk = function (key, types) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = this.d13_1(key, types);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  //region block: post-declaration
  protoOf(SerialDescriptorImpl).ek = get_isNullable;
  protoOf(SerialDescriptorImpl).nk = get_isInline;
  protoOf(AbstractDecoder).sm = decodeSerializableElement$default;
  protoOf(AbstractDecoder).em = decodeSerializableValue;
  protoOf(AbstractDecoder).vm = decodeSequentially;
  protoOf(AbstractDecoder).xm = decodeCollectionSize;
  protoOf(AbstractEncoder).ao = encodeNotNullMark;
  protoOf(AbstractEncoder).bo = beginCollection;
  protoOf(AbstractEncoder).xn = encodeSerializableValue;
  protoOf(AbstractEncoder).zn = encodeNullableSerializableValue;
  protoOf(AbstractEncoder).co = shouldEncodeElementDefault;
  protoOf(ListLikeDescriptor).ek = get_isNullable;
  protoOf(ListLikeDescriptor).nk = get_isInline;
  protoOf(ListLikeDescriptor).pk = get_annotations;
  protoOf(MapLikeDescriptor).ek = get_isNullable;
  protoOf(MapLikeDescriptor).nk = get_isInline;
  protoOf(MapLikeDescriptor).pk = get_annotations;
  protoOf(PluginGeneratedSerialDescriptor).ek = get_isNullable;
  protoOf(PluginGeneratedSerialDescriptor).nk = get_isInline;
  protoOf(InlinePrimitiveDescriptor$1).ju = typeParametersSerializers;
  protoOf(NothingSerialDescriptor).ek = get_isNullable;
  protoOf(NothingSerialDescriptor).nk = get_isInline;
  protoOf(NothingSerialDescriptor).pk = get_annotations;
  protoOf(PrimitiveSerialDescriptor_0).ek = get_isNullable;
  protoOf(PrimitiveSerialDescriptor_0).nk = get_isInline;
  protoOf(PrimitiveSerialDescriptor_0).pk = get_annotations;
  protoOf(TaggedDecoder).sm = decodeSerializableElement$default;
  protoOf(TaggedDecoder).em = decodeSerializableValue;
  protoOf(TaggedDecoder).vm = decodeSequentially;
  protoOf(TaggedDecoder).xm = decodeCollectionSize;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = SEALED_getInstance;
  _.$_$.b = STRING_getInstance;
  _.$_$.c = CONTEXTUAL_getInstance;
  _.$_$.d = ENUM_getInstance;
  _.$_$.e = CLASS_getInstance;
  _.$_$.f = LIST_getInstance;
  _.$_$.g = MAP_getInstance;
  _.$_$.h = OBJECT_getInstance;
  _.$_$.i = BooleanSerializer_getInstance;
  _.$_$.j = DoubleSerializer_getInstance;
  _.$_$.k = IntSerializer_getInstance;
  _.$_$.l = LongSerializer_getInstance;
  _.$_$.m = StringSerializer_getInstance;
  _.$_$.n = SerializationException_init_$Init$_0;
  _.$_$.o = SerializationException_init_$Create$_0;
  _.$_$.p = UnknownFieldException_init_$Create$;
  _.$_$.q = ListSerializer;
  _.$_$.r = MapSerializer;
  _.$_$.s = get_nullable;
  _.$_$.t = serializer_0;
  _.$_$.u = serializer_4;
  _.$_$.v = serializer_2;
  _.$_$.w = serializer_3;
  _.$_$.x = serializer_1;
  _.$_$.y = PolymorphicKind;
  _.$_$.z = PrimitiveKind;
  _.$_$.a1 = PrimitiveSerialDescriptor;
  _.$_$.b1 = get_annotations;
  _.$_$.c1 = get_isInline;
  _.$_$.d1 = get_isNullable;
  _.$_$.e1 = SerialDescriptor;
  _.$_$.f1 = ENUM;
  _.$_$.g1 = buildSerialDescriptor;
  _.$_$.h1 = getContextualDescriptor;
  _.$_$.i1 = AbstractDecoder;
  _.$_$.j1 = AbstractEncoder;
  _.$_$.k1 = CompositeDecoder;
  _.$_$.l1 = CompositeEncoder;
  _.$_$.m1 = Decoder;
  _.$_$.n1 = Encoder;
  _.$_$.o1 = AbstractPolymorphicSerializer;
  _.$_$.p1 = ArrayListSerializer;
  _.$_$.q1 = ElementMarker;
  _.$_$.r1 = typeParametersSerializers;
  _.$_$.s1 = GeneratedSerializer;
  _.$_$.t1 = InlinePrimitiveDescriptor;
  _.$_$.u1 = LinkedHashMapSerializer;
  _.$_$.v1 = LinkedHashSetSerializer;
  _.$_$.w1 = NamedValueDecoder;
  _.$_$.x1 = PluginGeneratedSerialDescriptor;
  _.$_$.y1 = SerializerFactory;
  _.$_$.z1 = createSimpleEnumSerializer;
  _.$_$.a2 = jsonCachedSerialNames;
  _.$_$.b2 = throwMissingFieldException;
  _.$_$.c2 = EmptySerializersModule_0;
  _.$_$.d2 = contextual;
  _.$_$.e2 = SerializersModuleCollector;
  _.$_$.f2 = DeserializationStrategy;
  _.$_$.g2 = KSerializer;
  _.$_$.h2 = MissingFieldException;
  _.$_$.i2 = SealedClassSerializer;
  _.$_$.j2 = SerializableWith;
  _.$_$.k2 = SerializationException;
  _.$_$.l2 = SerializationStrategy;
  _.$_$.m2 = findPolymorphicSerializer;
  _.$_$.n2 = findPolymorphicSerializer_0;
  _.$_$.o2 = serializer;
  //endregion
  return _;
}));

